<!--
index_1 미디어 내부 채널 분류 (overall, 채널 , 기타매체)
index_2 미디어별로 통합 리치 계산
  index_2-1 TV미디어 통합리치 계산
  index_2-2 PC미디어 통합리치 계산
  index_2-3 Mobile 미디어 통합리치 계산
  index_2-4 Digital 미디어 통합리치 계산
index_3
  index_3-1 A2 Logic
  index_3-2 A3 Logic
  index_3-3 B Logic
  index_3-4 C Logic
index_4 결과 데이터 만들기 (table / VennDiagram ... )
  index_4-1 TV매체 결과데이터만들기
  index_4-2 PC매체 결과데이터만들기
  index_4-3 mobile매체 결과데이터만들기
  index_4-4 digital매체 결과데이터만들기
index_5
  index_5-1 1screen 벤다이어그램 그리기
  index_5-2 2screen 벤다이어그램 그리기
  index_5-3 3screen 벤다이어그램 그리기
  index_5-4 4screen 벤다이어그램 그리기
index_6 토탈레벨 분석
  index_6-1 토탈레벨 분석코드 생성
  index_6-2 토탈레벨 데이터 분석
-->
<template>
<div class="animated fadeIn">
  <b-card style="height:500px" class="bs-callout bs-callout-primary panelScrollBar">
    <resize-observer @notify="handleResize" />
    <div style="min-width: 1200px;">
      <b-row style="padding-bottom:35px;">
        <b-col sm="6">
          <span class="float-left card-title wise-card-title">Total Level Result </span>
          <!-- <span class="small text-muted wise-card-subtitle"> Toal Level Result</span> -->
          <reachHelpResult01></reachHelpResult01>
          <reachHelpResult02></reachHelpResult02>
        </b-col>
        <b-col sm="6">
          <span class="float-right">
            <b-button block variant="outline-primary" class="btn-pill" @click="totalLevelChartChangeFn">
              <span style="font-weight:900;">{{totalLevelChartChangeLable}}</span>
            </b-button>
          </span>
          <reachHelpResult03></reachHelpResult03>
        </b-col>
        <b-col sm="5">
          <br/>
          <b-card class="text-white bg-success">
            <span class="h4 m-0" style="padding-right:20px">총예산 | </span>
            <span class="h2 m-0">{{formData.totalBudget | separator}}만원</span>
          </b-card>
          <b-card class="text-white bg-success">
            <span class="h4 m-0" style="padding-right:20px">타겟 | </span>
            <span class="h2 m-0">{{formData.targetCode}}({{formData.demographic_cnt | separator}})</span>
          </b-card>
          <b-card class="text-white bg-primary">
            <span class="h4 m-0" style="padding-right:10px">Reach 1+ | </span>
            <span class="h2 m-0" style="padding-right:50px">{{totalMedia.resultMedia.reach1 | numeral('0.00')}}</span>
            <span class="h4 m-0" style="padding-right:10px">Reach 3+ | </span>
            <span class="h2 m-0">{{totalMedia.resultMedia.reach3 | numeral('0.00')}}</span>
          </b-card>
          <b-card class="text-white bg-primary">
            <span class="h4 m-0" style="padding-right:10px">Total GRPS | </span>
            <span class="h2 m-0" style="padding-right:50px">{{totalMedia.resultMedia.grps | numeral('0.00')}}</span>
            <span class="h4 m-0" style="padding-right:10px">A.F | </span>
            <span class="h2 m-0">{{totalMedia.resultMedia.grps / totalMedia.resultMedia.reach1 | numeral('0.00')}}</span>
          </b-card>
        </b-col>
        <b-col sm="1">
        </b-col>
        <b-col v-if="!showResult" sm="6" >
          <loading></loading>
        </b-col>
        <div  v-show="showResult">
          <b-col sm="6" v-show="totalLevelChartChange" class="animated fadeIn">
            <div id="mediaLevel_TOTAL_Venn1"></div>
          </b-col>
          <b-col sm="6" v-show="!totalLevelChartChange" class="animated fadeIn">
            <div id="txt3" ></div>
            <div id="mediaLevel_TOTAL_Venn2" >
            </div>
          </b-col>
        </div>
      </b-row>
    </div>
  </b-card>
  <b-card style="height:500px" class="bs-callout bs-callout-primary panelScrollBar">
    <resize-observer @notify="handleResize" />
    <div style="min-width: 1200px;">
      <b-row style="padding-bottom:35px;">
        <b-col sm="12">
          <span class="card-title wise-card-title">Media Level Result </span>
          <span class="small text-muted wise-card-subtitle"> Media Level Result</span>
          <span class="float-right">
            <b-button block variant="outline-primary" class="btn-pill" @click="chartChangeFn">
              <span style="font-weight:900;">{{chartChangeLable}}</span>
            </b-button>
          </span>
        </b-col>
        <b-col sm="6">
          <br/>
          <table  id="mediaTable"
                  data-search="false"
                  data-show-columns="false"
                  data-pagination="false"
                  data-detail-view="true"
                  data-detail-formatter="detailFormatter"
                  >
              <thead>
                  <tr>
                      <th data-field="media">미디어</th>
                      <th data-field="target">output 타겟</th>
                      <th data-field="budgetLabel">예산(만원)</th>
                      <th data-field="cpmLabel">CPM</th>
                      <th data-field="grps">GRPs</th>
                      <th data-field="reach1" >Reach 1+</th>
                      <th data-field="reach3" >Reach 3+</th>
                      <th data-field="af" >A.F</th>
                  </tr>
              </thead>
          </table>
        </b-col>
        <b-col v-if="!showResult" sm="6" >
          <loading></loading>
        </b-col>
        <div v-show="showResult">
          <div v-show="tvMediaShow">
            <b-col sm="6" v-show="chartChange" class="animated fadeIn">
              <div id="mediaLevel_TV_Venn1"></div>
            </b-col>
            <b-col sm="6" v-show="!chartChange" class="animated fadeIn">
              <div id="mediaLevel_TV_Venn2" >
              </div>
            </b-col>
          </div>
          <div v-show="pcMediaShow">
            <b-col sm="6" v-show="chartChange" class="animated fadeIn">
              <div id="mediaLevel_PC_Venn1"></div>
            </b-col>
            <b-col sm="6" v-show="!chartChange" class="animated fadeIn">
              <div id="mediaLevel_PC_Venn2" >
              </div>
            </b-col>
          </div>
          <div v-show="mobileMediaShow">
            <b-col sm="6" v-show="chartChange" class="animated fadeIn">
              <div id="mediaLevel_Mobile_Venn1"></div>
            </b-col>
            <b-col sm="6" v-show="!chartChange" class="animated fadeIn">
              <div id="mediaLevel_Mobile_Venn2" >
              </div>
            </b-col>
          </div>
          <div v-show="digitalMediaShow">
            <b-col sm="6" v-show="chartChange" class="animated fadeIn">
              <div id="mediaLevel_Digital_Venn1"></div>
            </b-col>
            <b-col sm="6" v-show="!chartChange" class="animated fadeIn">
              <div id="mediaLevel_Digital_Venn2" >
              </div>
            </b-col>
          </div>
        </div>
      </b-row>
    </div>
  </b-card>
</div>
</template>

<script>
import reachFormData from "../../common/ReachFormData.js";
import mediaLevelChart from "./mediaLevelChart.js";
import bootstrapTable from "bootstrap-table";
import select2 from "select2/dist/js/select2.full.min.js";
import * as venn from "venn.js/build/venn.js";
import * as d3 from "d3v4/build/d3.min.js";
import reach3Logic from "../../common/Reach3Logic.js";
import reachHelpResult01 from "../../helpModals/reach/reachHelpResult01.vue";
import reachHelpResult02 from "../../helpModals/reach/reachHelpResult02.vue";
import reachHelpResult03 from "../../helpModals/reach/reachHelpResult03.vue";
import loading from '../../common/blockLoading.vue'; // 로딩중

export default {
  components : {
  'reachHelpResult01' : reachHelpResult01,
  'reachHelpResult02' : reachHelpResult02,
  'reachHelpResult03' : reachHelpResult03,
  'loading' : loading
  },
  props: {
    rootFormData:null,
  },
  // index_data
  data() {
    return {
      showResult : false,
      completeClassifyMedia: false,
      formData: this.$_.clone(this.$session.get('inputFormData')),
      constFormData: this.$_.clone(this.$session.get('inputFormData').mediaListResult),
      chartData: [],
      inte_cffcnt:{},
      inte_cffcnt_N:{},
      tableData: null,
      // graphIndex:0,
      tvMedia:{
        inte_ModelCode:'',
        overall:null,
        mediaList: {},
        resultMedia:null,
        screenCount: 1,
      },
      mobileMedia :{
        inte_ModelCode:'',
        overall:null,
        mediaList: {},
        etcMediaList:[],
        resultMedia:null,
        screenCount: 1,
      },
      pcMedia:{
        inte_ModelCode:'',
        overall:null,
        mediaList: {},
        etcMediaList:[],
        resultMedia:null,
        screenCount: 1,
      },
      digitalMedia:{
        inte_ModelCode:'',
        overall:null,
        mediaList: {},
        etcMediaList:[],
        resultMedia:null,
        screenCount: 1,
      },
      totalMedia:{
        // inte_ModelCode:'',
        // overall:null,
        // mediaList: {},
        // etcMediaList:[],
        resultMedia:this.$_.clone(reachFormData.mediaInfo),
        // screenCount: 1,
      },
      mediaProcessingFlag:0,
      chartChangeLable:'교집합 벤다이어그램',
      totalLevelChartChangeLable:'교집합 벤다이어그램',
      chartChange:true,
      tvMediaShow:false,
      pcMediaShow:false,
      mobileMediaShow:false,
      digitalMediaShow:false,
      completeMediaLevelCalculation:false,
      totalLevelCode:'',
      totalLevelChartChange:true
    }
  }
  ,
  created: function() {}
  ,
  updated: function() {}
  ,
  mounted: function() {
    this.showResult = false;
    for(var i=0; i<this.formData.mediaListResult.length; i++) {
      this.formData.mediaListResult[i].eImp = this.formData.mediaListResult[i].outputImpression;
      this.formData.mediaListResult[i].outputTargetCode = this.formData.targetCode;
    }
    //  index_util 통합리치 계수 로딩
    this.getInteCffcnt();
  }
  ,
  watch:{
     // index_pre 이전레벨인 채널레벨의 결과분석이 끝나면 현재레벨인 미디어 레벨의 결과 분석 시작
    'rootFormData.completeChannelLevelCalculcation' : function(){
      this.classifyMedia();
    },
    // index_2 미디어별로 통합 리치 계산
    'completeClassifyMedia': function() {
      if(this.completeClassifyMedia){
        this.calcTVMedia(); // index_2-1 TV미디어 통합리치 계산
        this.calcPCMediaPreprocessing(); // index_2-2 PC미디어 통합리치 계산
        this.calcMobileMediaPreprocessing(); // index_2-3 Mobile 미디어 통합리치 계산
        this.calcDigitalMediaPreprocessing(); // index_2-4 Digital 미디어 통합리치 계산
      }
    },
    // index_4 결과 데이터 만들기 (table / VennDiagram ... )
    'mediaProcessingFlag': function(){
      if(this.mediaProcessingFlag >= 4){
        this.makeFinalMediaList();
      }
    },
    // index_6 토탈레벨 분석
    'completeMediaLevelCalculation':function(){
      if(this.completeMediaLevelCalculation){
        // index_6-1 토탈레벨 분석코드 생성
        this.makeTotalLevelCode();
        this.calcTotalLevel();
        this.totalMedia.resultMedia.grps = parseFloat(this.totalMedia.resultMedia.grps).toFixed(2);
        this.showResult = true;
      }
      this.rootFormData.totalMedia = this.totalMedia; // 2018-10-22 엑셀다운로드를 위해서 추가
    }
  },
  methods: {
    handleResize() {
      $('#mediaTable').bootstrapTable('resetView');
    },
    getInteCffcnt(){
      var token = sessionStorage.getItem("myToken");
      // 통합리치 계수데이터 로딩
      // this.$http.get('/api/select/allInteCffcnt?access_token='+token)
      //   .then((result) => {
      //     var list = result.data;
      //     for(var i=0; i<list.length; i++){
      //       this.inte_cffcnt[list[i].int_CFFCNT_CD] = list[i];
      //     }
      // });

      this.$http.get('/api/select/allInteCffcntN?access_token='+token)
        .then((result) => {
          var list = result.data;
          for(var i=0; i<list.length; i++){
            this.inte_cffcnt_N[list[i].int_CFFCNT_CD] = list[i];
          }
      });
    },
    // index_1 미디어 내부 채널 분류 (overall, 채널 , 기타매체)
    classifyMedia() {
      var channelLevelResult = this.rootFormData.channelLevelResultForMedia;
      this.$log.debug('Media Level Result channelLevelResult 객체값 : ', channelLevelResult);
      for(var i=0; i <channelLevelResult.length; i++){
        switch(channelLevelResult[i].media) {
            case 'TV':
                if(channelLevelResult[i].channel == '전체'){
                    this.tvMedia.overall = channelLevelResult[i];
                }else{
                  var code = channelLevelResult[i].channel.charAt(0);
                  this.tvMedia.inte_ModelCode += code;
                  this.tvMedia.mediaList[channelLevelResult[i].channel] = channelLevelResult[i];
                }

                break;
            case 'PC':
                if(channelLevelResult[i].channel == '전체'){
                    this.pcMedia.overall = channelLevelResult[i];
                }else if(
                     channelLevelResult[i].channel == 'Daum'
                  || channelLevelResult[i].channel == 'Naver'
                  || channelLevelResult[i].channel == 'AfreecaTV'
                  || channelLevelResult[i].channel == 'Naver'
                  || channelLevelResult[i].channel == 'AfreecaTV'
                  || channelLevelResult[i].channel == 'PandoraTV'
                  || channelLevelResult[i].channel == 'GomTV'
                  || channelLevelResult[i].channel == 'SPOTV'
                  || channelLevelResult[i].channel == 'Tving'
                  || channelLevelResult[i].channel == 'Incross-다윈'
                  || channelLevelResult[i].channel == 'Mezzomedia-맨'
                  || channelLevelResult[i].channel == 'DMC-V1'
                ){
                  var existCode = this.pcMedia.inte_ModelCode.indexOf('E');
                  if(existCode>-1){
                  // 기타매체가 코드값에 포함됬으므로 별도의 작업은 하지 않는다.
                  }else{
                    this.pcMedia.inte_ModelCode += 'E';
                  }
                  this.pcMedia.etcMediaList.push(channelLevelResult[i]);
                  this.$log.debug('Media Level Result PC 기타매체 추가 : ' ,channelLevelResult[i]);
                }else {
                  var code = channelLevelResult[i].channel.charAt(0);
                  this.pcMedia.inte_ModelCode += code;
                  this.pcMedia.mediaList[channelLevelResult[i].channel] = channelLevelResult[i];
                }
                break;
            case 'Mobile':
                if(channelLevelResult[i].channel == '전체'){
                    this.mobileMedia.overall = channelLevelResult[i];
                }else if(
                     channelLevelResult[i].channel == 'Daum'
                  || channelLevelResult[i].channel == 'Naver'
                  || channelLevelResult[i].channel == 'AfreecaTV'
                  || channelLevelResult[i].channel == 'Naver'
                  || channelLevelResult[i].channel == 'AfreecaTV'
                  || channelLevelResult[i].channel == 'PandoraTV'
                  || channelLevelResult[i].channel == 'GomTV'
                  || channelLevelResult[i].channel == 'SPOTV'
                  || channelLevelResult[i].channel == 'Tving'
                  || channelLevelResult[i].channel == 'Incross-다윈'
                  || channelLevelResult[i].channel == 'Mezzomedia-맨'
                  || channelLevelResult[i].channel == 'DMC-V1'
                ){
                  var existCode = this.mobileMedia.inte_ModelCode.indexOf('E');
                  if(existCode>-1){
                    // 기타매체가 코드값에 포함됬으므로 별도의 작업은 하지 않는다.
                  }else{
                    this.mobileMedia.inte_ModelCode += 'E';
                  }
                  this.mobileMedia.etcMediaList.push(channelLevelResult[i]);
                  this.$log.debug('Media Level Result Mobile 기타매체 추가 : ' ,channelLevelResult[i]);
                }
                else{
                  var code = channelLevelResult[i].channel.charAt(0);
                  this.mobileMedia.inte_ModelCode += code;
                  this.mobileMedia.mediaList[channelLevelResult[i].channel] = channelLevelResult[i];
                }
                break;
            case 'Digital':
                if(channelLevelResult[i].channel == '전체'){
                    this.digitalMedia.overall = channelLevelResult[i];
                }else if(
                     channelLevelResult[i].channel == 'Daum'
                  || channelLevelResult[i].channel == 'Naver'
                  || channelLevelResult[i].channel == 'AfreecaTV'
                  || channelLevelResult[i].channel == 'Naver'
                  || channelLevelResult[i].channel == 'AfreecaTV'
                  || channelLevelResult[i].channel == 'PandoraTV'
                  || channelLevelResult[i].channel == 'GomTV'
                  || channelLevelResult[i].channel == 'SPOTV'
                  || channelLevelResult[i].channel == 'Tving'
                  || channelLevelResult[i].channel == 'Incross-다윈'
                  || channelLevelResult[i].channel == 'Mezzomedia-맨'
                  || channelLevelResult[i].channel == 'DMC-V1'
                ){
                  var existCode = this.digitalMedia.inte_ModelCode.indexOf('E');
                  if(existCode>-1){
                    // 기타매체가 코드값에 포함됬으므로 별도의 작업은 하지 않는다.
                  }else{
                    this.digitalMedia.inte_ModelCode += 'E';
                  }
                  this.digitalMedia.etcMediaList.push(channelLevelResult[i]);
                  this.$log.debug('Media Level Result 디지털 기타매체 추가 : ' ,channelLevelResult[i]);
                }
                else {
                  var code = channelLevelResult[i].channel.charAt(0);
                  this.digitalMedia.inte_ModelCode += code;
                  this.digitalMedia.mediaList[channelLevelResult[i].channel] = channelLevelResult[i];
                }
                break;
            }
          }
      this.sortModelCode(this.tvMedia);
      this.sortModelCode(this.pcMedia);
      this.sortModelCode(this.mobileMedia);
      this.sortModelCode(this.digitalMedia);
      this.completeClassifyMedia = true;
    },
    sortModelCode(mediaInfo){
      var str = mediaInfo.inte_ModelCode;
      str = str.split(""); // split the string in chunks
      str = str.sort();    // sorting
      str = str.join("");  // concatenate the chunks in one string
      mediaInfo.inte_ModelCode = str;
    },
    // index_2-1 TV미디어 통합리치 계산 (벤다이어그램 처리로직 일부 포함 - 기초데이터생성)
    calcTVMedia(){
      if(this.tvMedia.inte_ModelCode.length > 1){
        // 먼저 기타매체 처리로직
        switch(this.tvMedia.inte_ModelCode) {
          case '지케': // 지상파 케이블 , A2로직
              this.$log.debug('Media Level Result 통합리치 계산 TV [지상파/케이블]');
              this.tvMedia.screenCount = 2;
              this.tvMedia.reachA = this.tvMedia.mediaList['지상파'].reach1;
              this.tvMedia.reachALabel = '지상파';
              this.tvMedia.reachB = this.tvMedia.mediaList['케이블'].reach1;
              this.tvMedia.reachBLabel = '케이블';
              // this.A2_Logic(this.tvMedia, this.tvMedia.mediaList['지상파'], this.tvMedia.mediaList['케이블'], 'A2_2', 'media');
              this.BN2_Logic(this.tvMedia, this.tvMedia.mediaList['지상파'], this.tvMedia.mediaList['케이블'], 'BN2_3');
              this.$log.debug('Media Level Result 통합리치 계산 TV [지케] A2로직 reach1 : ' + this.tvMedia.resultMedia.reach1);
              break;
          case '종지': // 지상파 종편 , A2로직
              this.$log.debug('Media Level Result 통합리치 계산 TV [종편/지상파]');
              this.tvMedia.screenCount = 2;
              this.tvMedia.reachA = this.tvMedia.mediaList['지상파'].reach1;
              this.tvMedia.reachALabel = '지상파';
              this.tvMedia.reachB = this.tvMedia.mediaList['종편'].reach1;
              this.tvMedia.reachBLabel = '종편';
              // this.A2_Logic(this.tvMedia, this.tvMedia.mediaList['지상파'], this.tvMedia.mediaList['종편'], 'A2_3', 'media');
              this.BN2_Logic(this.tvMedia, this.tvMedia.mediaList['지상파'], this.tvMedia.mediaList['종편'], 'BN2_4');
              this.$log.debug('Media Level Result 통합리치 계산 TV [지종] A2로직 reach1 : ' + this.tvMedia.resultMedia.reach1);
              break;
          case '종케': // 종편 케이블 , A2로직
              this.$log.debug('Media Level Result 통합리치 계산 TV [종편/케이블]');
              this.tvMedia.screenCount = 2;
              this.tvMedia.reachA = this.tvMedia.mediaList['종편'].reach1;
              this.tvMedia.reachALabel = '종편';
              this.tvMedia.reachB = this.tvMedia.mediaList['케이블'].reach1;
              this.tvMedia.reachBLabel = '케이블';
              // this.A2_Logic(this.tvMedia, this.tvMedia.mediaList['종편'], this.tvMedia.mediaList['케이블'], 'A2_4', 'media');
              this.BN2_Logic(this.tvMedia, this.tvMedia.mediaList['케이블'], this.tvMedia.mediaList['종편'], 'BN2_5');
              this.$log.debug('Media Level Result 통합리치 계산 TV [종케] A2로직 reach1 : ' + this.tvMedia.resultMedia.reach1);
              break;
          case '종지케': // 지상파 종편 케이블 A3로직
              this.$log.debug('Media Level Result 통합리치 계산 TV [종편/지상파/케이블]');
              this.tvMedia.screenCount = 3;
              this.tvMedia.reachA = this.tvMedia.mediaList['지상파'].reach1;
              this.tvMedia.reachALabel = '지상파';
              this.tvMedia.reachB = this.tvMedia.mediaList['종편'].reach1;
              this.tvMedia.reachBLabel = '종편';
              this.tvMedia.reachC = this.tvMedia.mediaList['케이블'].reach1;
              this.tvMedia.reachCLabel = '케이블';

              // this.A2_Logic(this.tvMedia, this.tvMedia.mediaList['지상파'], this.tvMedia.mediaList['종편'], 'A2_3', 'media');
              this.BN2_Logic(this.tvMedia, this.tvMedia.mediaList['지상파'], this.tvMedia.mediaList['종편'], 'BN2_4');
              this.tvMedia.reachAB = this.tvMedia.resultMedia.reach1;
              this.$log.debug('Media Level Result 통합리치 계산 TV [지종] A2로직 reach1 : ' + this.tvMedia.reachAB);

              // this.A2_Logic(this.tvMedia, this.tvMedia.mediaList['지상파'], this.tvMedia.mediaList['케이블'], 'A2_2', 'media');
              this.BN2_Logic(this.tvMedia, this.tvMedia.mediaList['지상파'], this.tvMedia.mediaList['케이블'], 'BN2_3');
              this.tvMedia.reachAC = this.tvMedia.resultMedia.reach1;
              this.$log.debug('Media Level Result 통합리치 계산 TV [지케] A2로직 reach1 : ' + this.tvMedia.reachAC);

              // this.A2_Logic(this.tvMedia, this.tvMedia.mediaList['종편'], this.tvMedia.mediaList['케이블'], 'A2_4', 'media');
              this.BN2_Logic(this.tvMedia, this.tvMedia.mediaList['케이블'], this.tvMedia.mediaList['종편'], 'BN2_5');
              this.tvMedia.reachBC = this.tvMedia.resultMedia.reach1;
              this.$log.debug('Media Level Result 통합리치 계산 TV [종케] A2로직 reach1 : ' + this.tvMedia.reachBC);

              // this.A3_Logic(this.tvMedia, this.tvMedia.mediaList['지상파'], this.tvMedia.mediaList['종편'], this.tvMedia.mediaList['케이블'],'A3_1', 'media');
              this.BN3_Logic(this.tvMedia, this.tvMedia.mediaList['지상파'], this.tvMedia.mediaList['종편'], this.tvMedia.mediaList['케이블'],'BN3_1', 'channel');
              this.tvMedia.reachABC = this.tvMedia.resultMedia.reach1;
              this.$log.debug('Media Level Result 통합리치 계산 TV [지종케] A3로직 reach1 : ' + this.tvMedia.reachABC);
              break;
        }
      }else if(this.tvMedia.inte_ModelCode.length == 1){
        switch (this.tvMedia.inte_ModelCode) {
          case '지':
            this.tvMedia.resultMedia = this.tvMedia.mediaList['지상파'];
            this.$log.debug('Media Level Result 통합리치 계산 TV [지상파] reach1 : ' + this.tvMedia.resultMedia.reach1);
            break;
          case '종':
            this.tvMedia.resultMedia = this.tvMedia.mediaList['종편'];
            this.$log.debug('Media Level Result 통합리치 계산 TV [종편] reach1 : ' + this.tvMedia.resultMedia.reach1);
            break;
          case '케':
            this.tvMedia.resultMedia = this.tvMedia.mediaList['케이블'];
            this.$log.debug('Media Level Result 통합리치 계산 TV [케이블] reach1 : ' + this.tvMedia.resultMedia.reach1);
            break;
          default:
        }

      }else if(this.tvMedia.overall !== null && this.tvMedia.inte_ModelCode == ''){
        this.tvMedia.resultMedia = this.tvMedia.overall;
      }else if(this.tvMedia.overall !== null && this.tvMedia.inte_ModelCode != ''){
      }else{

      }
      // TV매체 처리로직 종료
      this.mediaProcessingFlag++;
    },
    clacSudoGRPs(cffcnt, reach1){
      // var result = Math.exp( (-1*cffcnt.a) - Math.log(cffcnt.lmt/(reach1/100)-1)/cffcnt.b1);
      var result = Math.exp( ((-1*cffcnt.a) - Math.log(cffcnt.lmt/(reach1/100)-1)) /cffcnt.b1);
      return result;
    },
    // index_2-2 PC미디어 통합리치 계산
    calcPCMediaPreprocessing(){
      this.$log.debug('Media Level Result PC미디어 전처리');
      this.$log.debug('Media Level Result PC미디어 전처리 Inte Model Code : ' + this.pcMedia.inte_ModelCode);
      if(this.pcMedia.inte_ModelCode.length > 1 || this.pcMedia.etcMediaList.length > 1){
        // 먼저 기타매체 처리로직
        // 기타매체가 한개냐 둘이상이냐에 따라 로직이 달라짐
        if(this.pcMedia.etcMediaList.length > 1){
          this.$log.debug('Media Level Result PC미디어 전처리 기타매체 개수 : ' + this.pcMedia.etcMediaList.length);
          // C2 Logic 적용
          var maxReach = 0;
          var inteReach = 0;
          var queryParams = [];

          for(var i=0; i<this.pcMedia.etcMediaList.length; i++){
            inteReach += parseFloat(this.pcMedia.etcMediaList[i].reach1);
            if(this.pcMedia.etcMediaList[i].reach1 > maxReach){
              maxReach = this.pcMedia.etcMediaList[i].reach1;
            }
            queryParams.push(this.$_.clone(this.pcMedia.etcMediaList[i])); // 0번째 미디어 통합 계수를 위해서
          }
          // 파라미터 만들기 pc overall;
          queryParams[0].channel = 'overall';
          // 계수 읽어오기
          var token = sessionStorage.getItem("myToken");
          var param = encodeURI(JSON.stringify(queryParams));

          this.$http.post('/api/select/cffcntBetaRegression?access_token='+token+'&objs='+param)
            .then((result) => {
              var inteGRP = 0;
              var cffcnt = result.data[0];
              for(var i=0; i <result.data.length; i++){
                inteGRP += this.clacSudoGRPs(cffcnt, this.pcMedia.etcMediaList[i].reach1);
              }

              result.data[0].reach1 = this.calculationReach(result.data[0], inteGRP);
              result.data[0].grps = inteGRP;

              if(result.data[0].reach1 > maxReach && result.data[0].reach1 < inteReach){
              }else{
                if(result.data[0].reach1 <= maxReach){
                  result.data[0].reach1 = maxReach;
                }else if(result.data[0].reach1 >= inteReach){
                  result.data[0].reach1 = inteReach;
                }
              }
              this.pcMedia.mediaList['Etc'] = result.data[0];

              this.$log.debug('Media Level Result PC미디어 전처리 기타매체 통합리치 : ' + this.pcMedia.mediaList['Etc'].reach1);
              this.pcMedia.resultMedia = this.pcMedia.mediaList['Etc']; // 18.11.22
              this.pcMedia.resultMedia.target_cnt = this.pcMedia.etcMediaList[0].target_cnt; // 18.11.23
              this.calcPCMedia();
            });
        }else if(this.pcMedia.etcMediaList.length == 1){
          this.pcMedia.mediaList['Etc'] = this.pcMedia.etcMediaList[0];
          this.calcPCMedia();
        }else{ // 기타 매체가 없을 경우
          this.calcPCMedia();
        }

      }else if(this.pcMedia.inte_ModelCode.length == 1 && this.pcMedia.etcMediaList.length < 2){
        this.$log.debug('Media Level Result PC미디어 전처리 , 단일 모델 처리 (Y/F/S/E)');
        switch (this.pcMedia.inte_ModelCode) {
          case 'Y':
            this.pcMedia.resultMedia = this.pcMedia.mediaList['Youtube'];
            break;
          case 'F':
            this.pcMedia.resultMedia = this.pcMedia.mediaList['Facebook'];
            break;
          case 'S':
            this.pcMedia.resultMedia = this.pcMedia.mediaList['SMR'];
            break;
          case 'E':
            this.pcMedia.mediaList['Etc'] = this.pcMedia.etcMediaList[0]; // 18.09.13
            this.pcMedia.resultMedia = this.pcMedia.mediaList['Etc'];
            break;
          default:
        }
        this.calcPCMedia();
      }else if(this.pcMedia.overall !== null && this.pcMedia.inte_ModelCode == ''){
        this.$log.debug('Media Level Result PC미디어 전처리 , Overall 모델처리 , 채널(Y/F/S/E)없음');
        this.pcMedia.resultMedia = this.pcMedia.overall;
        this.calcPCMedia();
      }else if(this.pcMedia.overall !== null && this.pcMedia.inte_ModelCode != ''){
        this.$log.debug('Media Level Result PC미디어 전처리 , Overall 모델처리 , 채널(Y/F/S/E)존재');
        this.calcPCMedia();
      }else{
        this.calcPCMedia();
      }
    },
    // index_2-2 PC미디어 통합리치 계산
    calcPCMedia(){
      if(this.pcMedia.inte_ModelCode.length > 1){
        switch(this.pcMedia.inte_ModelCode) {
          case 'SY': // SMR Youtube , A2 Logic
              this.$log.debug('Media Level Result 통합리치 계산 PC [SMR/Youtube]');
              this.pcMedia.screenCount = 2;
              this.pcMedia.reachA = this.pcMedia.mediaList['Youtube'].reach1;
              this.pcMedia.reachALabel = 'Youtube';
              this.pcMedia.reachB = this.pcMedia.mediaList['SMR'].reach1;
              this.pcMedia.reachBLabel = 'SMR';
              // this.A2_Logic(this.pcMedia, this.pcMedia.mediaList['Youtube'], this.pcMedia.mediaList['SMR'], 'A2_1', 'media');
              this.BN2_Logic(this.pcMedia, this.pcMedia.mediaList['Youtube'], this.pcMedia.mediaList['SMR'], 'BN2_1');
              this.$log.debug('Media Level Result 통합리치 계산 PC [YS] A2로직 reach1 : ' + this.pcMedia.resultMedia.reach1);
              break;
          case 'FY': // Facebook Youbute , B Logic
              this.$log.debug('Media Level Result 통합리치 계산 PC [Facebook/Youtube]');
              this.pcMedia.screenCount = 2;
              this.pcMedia.reachA = this.pcMedia.mediaList['Facebook'].reach1;
              this.pcMedia.reachALabel = 'Facebook';
              this.pcMedia.reachB = this.pcMedia.mediaList['Youtube'].reach1;
              this.pcMedia.reachBLabel = 'Youtube';
              this.BN2_Logic(this.pcMedia, this.pcMedia.mediaList['Youtube'], this.pcMedia.mediaList['Facebook'], 'BN2_2');
              this.$log.debug('Media Level Result 통합리치 계산 PC [FY] B로직 reach1 : ' + this.pcMedia.resultMedia.reach1);
              break;
          case 'EY': // 기타매체, Youtube , C Logic
              this.$log.debug('Media Level Result 통합리치 계산 PC [기타매체/Youtube]');
              // this.C_Logic(this.pcMedia, this.pcMedia.mediaList['Youtube'], this.pcMedia.mediaList['Etc']);
              this.CN_Logic(this.pcMedia, this.pcMedia.mediaList['Youtube'], this.pcMedia.mediaList['Etc']);
              this.$log.debug('Media Level Result 통합리치 계산 PC [YE] C로직 reach1 : ' + this.pcMedia.resultMedia.reach1);
              this.pcMedia.screenCount = 2;
              this.pcMedia.reachA = this.pcMedia.mediaList['Youtube'].reach1;
              this.pcMedia.reachALabel = 'Youtube';
              this.pcMedia.reachB = this.pcMedia.mediaList['Etc'].reach1;
              this.pcMedia.reachBLabel = 'Etc';
              break;
          case 'FS': // Facebook SMR , B Logic
            this.$log.debug('Media Level Result 통합리치 계산 PC [Facebook/SMR]');
              this.pcMedia.screenCount = 2;
              this.pcMedia.reachA = this.pcMedia.mediaList['Facebook'].reach1;
              this.pcMedia.reachALabel = 'Facebook';
              this.pcMedia.reachB = this.pcMedia.mediaList['SMR'].reach1;
              this.pcMedia.reachBLabel = 'SMR';
              // this.B_Logic(this.pcMedia, this.pcMedia.mediaList['Facebook'], this.pcMedia.mediaList['SMR']);
              this.BN2_Logic(this.pcMedia, this.pcMedia.mediaList['SMR'], this.pcMedia.mediaList['Facebook'], 'BN2_2');
              this.$log.debug('Media Level Result 통합리치 계산 PC [FS] B로직 reach1 : ' + this.pcMedia.resultMedia.reach1);
              break;
          case 'ES': // 기타매체 SMR , C Logic
              this.$log.debug('Media Level Result 통합리치 계산 PC [기타매체/SMR]');
              this.pcMedia.screenCount = 2;
              this.pcMedia.reachA = this.pcMedia.mediaList['SMR'].reach1;
              this.pcMedia.reachALabel = 'SMR';
              this.pcMedia.reachB = this.pcMedia.mediaList['Etc'].reach1;
              this.pcMedia.reachBLabel = 'Etc';
              // this.C_Logic(this.pcMedia, this.pcMedia.mediaList['SMR'], this.pcMedia.mediaList['Etc']);
              this.CN_Logic(this.pcMedia, this.pcMedia.mediaList['SMR'], this.pcMedia.mediaList['Etc']);
              this.$log.debug('Media Level Result 통합리치 계산 PC [SE] C로직 reach1 : ' + this.pcMedia.resultMedia.reach1);
              break;
          case 'EF': // 기타매체 Facebook , C Logic
              this.$log.debug('Media Level Result 통합리치 계산 PC [기타매체/Facebook]');
              this.pcMedia.screenCount = 2;
              this.pcMedia.reachA = this.pcMedia.mediaList['Facebook'].reach1;
              this.pcMedia.reachALabel = 'Facebook';
              this.pcMedia.reachB = this.pcMedia.mediaList['Etc'].reach1;
              this.pcMedia.reachBLabel = 'Etc';
              // this.C_Logic(this.pcMedia, this.pcMedia.mediaList['Facebook'], this.pcMedia.mediaList['Etc']);
              this.CN_Logic(this.pcMedia, this.pcMedia.mediaList['Facebook'], this.pcMedia.mediaList['Etc']);
              this.$log.debug('Media Level Result 통합리치 계산 PC [FE] C로직 reach1 : ' + this.pcMedia.resultMedia.reach1);
              break;
          case 'FSY': // Facebook SMR Youtube , A2 Logic - B Logic
              this.$log.debug('Media Level Result 통합리치 계산 PC [Facebook/SMR/Youtube]');
              // this.A2_Logic(this.pcMedia, this.pcMedia.mediaList['Youtube'], this.pcMedia.mediaList['SMR'], 'A2_1', 'media');
              this.BN2_Logic(this.pcMedia, this.pcMedia.mediaList['Youtube'], this.pcMedia.mediaList['SMR'], 'BN2_1');
              this.$log.debug('Media Level Result 통합리치 계산 PC [YS] A2로직 reach1 : ' + this.pcMedia.resultMedia.reach1);
              var A2LogicChannel = this.$_.clone(this.pcMedia.resultMedia);
              // [start 벤다이어그램용]
              this.pcMedia.screenCount = 3;
              this.pcMedia.reachA = this.pcMedia.mediaList['Youtube'].reach1;
              this.pcMedia.reachALabel = 'Youtube';
              this.pcMedia.reachB = this.pcMedia.mediaList['SMR'].reach1;
              this.pcMedia.reachBLabel = 'SMR';
              this.pcMedia.reachC = this.pcMedia.mediaList['Facebook'].reach1;
              this.pcMedia.reachCLabel = 'Facebook';

              this.pcMedia.reachAB = this.pcMedia.resultMedia.reach1;

              // this.B_Logic(this.pcMedia, this.pcMedia.mediaList['Facebook'], this.pcMedia.mediaList['Youtube']);
              this.BN2_Logic(this.pcMedia, this.pcMedia.mediaList['Youtube'], this.pcMedia.mediaList['Facebook'], 'BN2_2');
              this.pcMedia.reachAC = this.pcMedia.resultMedia.reach1;
              this.$log.debug('Media Level Result 통합리치 계산 PC [FY] B로직 reach1 : ' + this.pcMedia.reachAC);

              // this.B_Logic(this.pcMedia, this.pcMedia.mediaList['Facebook'], this.pcMedia.mediaList['SMR']);
              this.BN2_Logic(this.pcMedia, this.pcMedia.mediaList['SMR'], this.pcMedia.mediaList['Facebook'], 'BN2_2');
              this.pcMedia.reachBC = this.pcMedia.resultMedia.reach1;
              this.$log.debug('Media Level Result 통합리치 계산 PC [FS] B로직 reach1 : ' + this.pcMedia.reachBC);
              // [end   벤다이어그램용]
              // this.B_Logic(this.pcMedia, this.pcMedia.mediaList['Facebook'], A2LogicChannel);
              this.BN2_Logic(this.pcMedia, A2LogicChannel, this.pcMedia.mediaList['Facebook'], 'BN2_2');
              this.pcMedia.reachABC = this.pcMedia.resultMedia.reach1; // 밴다이어그램용
              this.$log.debug('Media Level Result 통합리치 계산 PC [FYS] B로직 reach1 : ' + this.pcMedia.reachABC);

              break;
          case 'EFY': // 기타매체 Facebook Youtube , C Logic - B Logic
              this.$log.debug('Media Level Result 통합리치 계산 PC [기타매체/Facebook/Youtube]');
              // this.C_Logic(this.pcMedia, this.pcMedia.mediaList['Youtube'], this.pcMedia.mediaList['Etc']);
              this.CN_Logic(this.pcMedia, this.pcMedia.mediaList['Youtube'], this.pcMedia.mediaList['Etc']);
              this.$log.debug('Media Level Result 통합리치 계산 PC [YE] C로직 reach1 : ' + this.pcMedia.resultMedia.reach1);
              var CLogicChannel = this.$_.clone(this.pcMedia.resultMedia);
              // [start 벤다이어그램용]
              this.pcMedia.screenCount = 3;
              this.pcMedia.reachA = this.pcMedia.mediaList['Youtube'].reach1;
              this.pcMedia.reachALabel = 'Youtube';
              this.pcMedia.reachB = this.pcMedia.mediaList['Etc'].reach1;
              this.pcMedia.reachBLabel = 'Etc';
              this.pcMedia.reachC = this.pcMedia.mediaList['Facebook'].reach1;
              this.pcMedia.reachCLabel = 'Facebook';

              this.pcMedia.reachAB = this.pcMedia.resultMedia.reach1;

              // this.B_Logic(this.pcMedia, this.pcMedia.mediaList['Facebook'], this.pcMedia.mediaList['Youtube']);
              this.BN2_Logic(this.pcMedia, this.pcMedia.mediaList['Youtube'], this.pcMedia.mediaList['Facebook'], 'BN2_2');
              this.pcMedia.reachAC = this.pcMedia.resultMedia.reach1;
              this.$log.debug('Media Level Result 통합리치 계산 PC [FY] B로직 reach1 : ' + this.pcMedia.reachAC);

              // this.C_Logic(this.pcMedia, this.pcMedia.mediaList['Facebook'], this.pcMedia.mediaList['Etc']);
              this.CN_Logic(this.pcMedia, this.pcMedia.mediaList['Facebook'], this.pcMedia.mediaList['Etc']);
              this.pcMedia.reachBC = this.pcMedia.resultMedia.reach1;
              this.$log.debug('Media Level Result 통합리치 계산 PC [FE] C로직 reach1 : ' + this.pcMedia.reachBC);
              // [end   벤다이어그램용]
              // this.B_Logic(this.pcMedia, this.pcMedia.mediaList['Facebook'], CLogicChannel);
              this.BN2_Logic(this.pcMedia, CLogicChannel, this.pcMedia.mediaList['Facebook'], 'BN2_2');
              this.pcMedia.reachABC = this.pcMedia.resultMedia.reach1; // 밴다이어그램용
              this.$log.debug('Media Level Result 통합리치 계산 PC [FYE] C로직 reach1 : ' + this.pcMedia.reachABC);
              break;
          case 'ESY': // 기타매체 SMR Youtube , A2 Logic - C Logic
              this.$log.debug('Media Level Result 통합리치 계산 PC [기타매체/SMR/Youtube]');
              // this.A2_Logic(this.pcMedia, this.pcMedia.mediaList['Youtube'], this.pcMedia.mediaList['SMR'], 'A2_1', 'media');
              this.BN2_Logic(this.pcMedia, this.pcMedia.mediaList['Youtube'], this.pcMedia.mediaList['SMR'], 'BN2_1');
              this.$log.debug('Media Level Result 통합리치 계산 PC [YS] A2로직 reach1 : ' + this.pcMedia.resultMedia.reach1);
              var A2LogicChannel = this.$_.clone(this.pcMedia.resultMedia);
              // [start 벤다이어그램용]
              this.pcMedia.screenCount = 3;
              this.pcMedia.reachA = this.pcMedia.mediaList['Youtube'].reach1;
              this.pcMedia.reachALabel = 'Youtube';
              this.pcMedia.reachB = this.pcMedia.mediaList['SMR'].reach1;
              this.pcMedia.reachBLabel = 'SMR';
              this.pcMedia.reachC = this.pcMedia.mediaList['Etc'].reach1;
              this.pcMedia.reachCLabel = 'Etc';

              this.pcMedia.reachAB = this.pcMedia.resultMedia.reach1;

              // this.C_Logic(this.pcMedia, this.pcMedia.mediaList['Youtube'], this.pcMedia.mediaList['Etc']);
              this.CN_Logic(this.pcMedia, this.pcMedia.mediaList['Youtube'], this.pcMedia.mediaList['Etc']);
              this.pcMedia.reachAC = this.pcMedia.resultMedia.reach1;
              this.$log.debug('Media Level Result 통합리치 계산 PC [YE] C로직 reach1 : ' + this.pcMedia.reachAC);

              // this.C_Logic(this.pcMedia, this.pcMedia.mediaList['SMR'], this.pcMedia.mediaList['Etc']);
              this.CN_Logic(this.pcMedia, this.pcMedia.mediaList['SMR'], this.pcMedia.mediaList['Etc']);
              this.pcMedia.reachBC = this.pcMedia.resultMedia.reach1;
              this.$log.debug('Media Level Result 통합리치 계산 PC [SE] C로직 reach1 : ' + this.pcMedia.reachBC);
              // [end   벤다이어그램용]

              // this.C_Logic(this.pcMedia, A2LogicChannel, this.pcMedia.mediaList['Etc']);
              this.CN_Logic(this.pcMedia, A2LogicChannel, this.pcMedia.mediaList['Etc']);
              this.pcMedia.reachABC = this.pcMedia.resultMedia.reach1; // 밴다이어그램용
              this.$log.debug('Media Level Result 통합리치 계산 PC [YSE] C로직 reach1 : ' + this.pcMedia.reachABC);

              break;
          case 'EFS': // 기타매체 Facebook SMR , C Logic - B Logic
              this.$log.debug('Media Level Result 통합리치 계산 PC [기타매체/Facebook/SMR]');
              // this.C_Logic(this.pcMedia, this.pcMedia.mediaList['SMR'], this.pcMedia.mediaList['Etc']);
              this.CN_Logic(this.pcMedia, this.pcMedia.mediaList['SMR'], this.pcMedia.mediaList['Etc']);
              this.$log.debug('Media Level Result 통합리치 계산 PC [SE] C로직 reach1 : ' + this.pcMedia.resultMedia.reach1);
              var CLogicChannel = this.$_.clone(this.pcMedia.resultMedia);
              // [start 벤다이어그램용]
              this.pcMedia.screenCount = 3;
              this.pcMedia.reachA = this.pcMedia.mediaList['SMR'].reach1;
              this.pcMedia.reachALabel = 'SMR';
              this.pcMedia.reachB = this.pcMedia.mediaList['Etc'].reach1;
              this.pcMedia.reachBLabel = 'Etc';
              this.pcMedia.reachC = this.pcMedia.mediaList['Facebook'].reach1;
              this.pcMedia.reachCLabel = 'Facebook';

              this.pcMedia.reachAB = this.pcMedia.resultMedia.reach1;

              // this.B_Logic(this.pcMedia, this.pcMedia.mediaList['Facebook'], this.pcMedia.mediaList['SMR']);
              this.BN2_Logic(this.pcMedia, this.pcMedia.mediaList['SMR'], this.pcMedia.mediaList['Facebook'], 'BN2_2');
              this.pcMedia.reachAC = this.pcMedia.resultMedia.reach1;
              this.$log.debug('Media Level Result 통합리치 계산 PC [FS] B로직 reach1 : ' + this.pcMedia.reachAC);

              // this.C_Logic(this.pcMedia, this.pcMedia.mediaList['Facebook'], this.pcMedia.mediaList['Etc']);
              this.CN_Logic(this.pcMedia, this.pcMedia.mediaList['Facebook'], this.pcMedia.mediaList['Etc']);
              this.pcMedia.reachBC = this.pcMedia.resultMedia.reach1;
              this.$log.debug('Media Level Result 통합리치 계산 PC [FE] C로직 reach1 : ' + this.pcMedia.reachBC);
              // [end   벤다이어그램용]
              // this.B_Logic(this.pcMedia, this.pcMedia.mediaList['Facebook'], CLogicChannel);
              this.BN2_Logic(this.pcMedia, CLogicChannel, this.pcMedia.mediaList['Facebook'], 'BN2_2');
              this.pcMedia.reachABC = this.pcMedia.resultMedia.reach1; // 밴다이어그램용
              this.$log.debug('Media Level Result 통합리치 계산 PC [FSE] B로직 reach1 : ' + this.pcMedia.reachABC);
              break;
          case 'EFSY': // A2 Logic - C Logic - B Logic
              this.$log.debug('Media Level Result 통합리치 계산 PC [기타매체/Facebook/SMR/Youtube]');
              this.pcMedia.screenCount = 4;
              // this.A2_Logic(this.pcMedia, this.pcMedia.mediaList['Youtube'], this.pcMedia.mediaList['SMR'], 'A2_1', 'media');
              this.BN2_Logic(this.pcMedia, this.pcMedia.mediaList['Youtube'], this.pcMedia.mediaList['SMR'], 'BN2_1');
              this.$log.debug('Media Level Result 통합리치 계산 PC [YS] A2로직 reach1 : ' + this.pcMedia.resultMedia.reach1);
              var A2LogicChannel = this.$_.clone(this.pcMedia.resultMedia);
              // this.C_Logic(this.pcMedia, A2LogicChannel, this.pcMedia.mediaList['Etc']);
              this.CN_Logic(this.pcMedia, A2LogicChannel, this.pcMedia.mediaList['Etc']);
              this.$log.debug('Media Level Result 통합리치 계산 PC [YSE] C로직 reach1 : ' + this.pcMedia.resultMedia.reach1);
              var CLogicChannel = this.$_.clone(this.pcMedia.resultMedia);
              // this.B_Logic(this.pcMedia, this.pcMedia.mediaList['Facebook'], CLogicChannel);
              this.BN2_Logic(this.pcMedia, CLogicChannel, this.pcMedia.mediaList['Facebook'], 'BN2_2');
              this.$log.debug('Media Level Result 통합리치 계산 PC [FYSE] B로직 reach1 : ' + this.pcMedia.resultMedia.reach1);
              break;
        }
      }else if(this.pcMedia.inte_ModelCode.length == 1){
        // PC GRPS 모델
      }else if(this.pcMedia.overall !== null){
        // PC-overall GRPS 모델
      }
      // PC매체 처리로직 종료
      this.mediaProcessingFlag++;
    },
    // index_2-2 mobile미디어 통합리치 계산
    calcMobileMediaPreprocessing(){
      this.$log.debug('Media Level Result Mobile미디어 전처리');
      this.$log.debug('Media Level Result Mobile미디어 전처리 Inte Model Code : ' + this.mobileMedia.inte_ModelCode);
      if(this.mobileMedia.inte_ModelCode.length > 1 || this.mobileMedia.etcMediaList.length > 1){
        // 먼저 기타매체 처리로직
        // 기타매체가 한개냐 둘이상이냐에 따라 로직이 달라짐
        if(this.mobileMedia.etcMediaList.length > 1){
          this.$log.debug('Media Level Result Mobile미디어 전처리 기타매체 개수 : ' + this.mobileMedia.etcMediaList.length);
          // C2 Logic 적용
          var maxReach = 0;
          var inteReach = 0;
          var queryParams = [];

          for(var i=0; i<this.mobileMedia.etcMediaList.length; i++){
            inteReach += parseFloat(this.mobileMedia.etcMediaList[i].reach1);
            if(this.mobileMedia.etcMediaList[i].reach1 > maxReach){
              maxReach = this.mobileMedia.etcMediaList[i].reach1;
            }
            queryParams.push(this.$_.clone(this.mobileMedia.etcMediaList[i]));
          }
          // 파라미터 만들기 mobile overall;
          queryParams[0].channel = 'overall';
          // 계수 읽어오기
          var token = sessionStorage.getItem("myToken");
          var param = encodeURI(JSON.stringify(queryParams));

          this.$http.post('/api/select/cffcntBetaRegression?access_token='+token+'&objs='+param)
            .then((result) => {
              var inteGRP = 0;
              var cffcnt = result.data[0];
              for(var i=0; i <result.data.length; i++){
                inteGRP += this.clacSudoGRPs(cffcnt, this.mobileMedia.etcMediaList[i].reach1);
              }

              result.data[0].reach1 = this.calculationReach(result.data[0], inteGRP);
              result.data[0].grps = inteGRP;
              if(result.data[0].reach1 > maxReach && result.data[0].reach1 < inteReach){
              }else{
                if(result.data[0].reach1 <= maxReach){
                  result.data[0].reach1 = maxReach;
                }else if(result.data[0].reach1 >= inteReach){
                  result.data[0].reach1 = inteReach;
                }
              }
              this.mobileMedia.mediaList['Etc'] = result.data[0];
              // 기타매체 최종 처리 완료
              this.$log.debug('Media Level Result Mobile미디어 전처리 기타매체 통합리치 : ' + this.mobileMedia.mediaList['Etc'].reach1);
              this.mobileMedia.resultMedia = this.mobileMedia.mediaList['Etc']; // 18.11.22
              this.mobileMedia.resultMedia.target_cnt = this.mobileMedia.etcMediaList[0].target_cnt; // 18.11.23
              this.calcMobileMedia();
            });
        }else if(this.mobileMedia.etcMediaList.length == 1){
          this.mobileMedia.mediaList['Etc'] = this.mobileMedia.etcMediaList[0];
          this.calcMobileMedia();
        }else{ // 기타 매체가 없을 경우
          this.calcMobileMedia();
        }

      }else if(this.mobileMedia.inte_ModelCode.length == 1 && this.mobileMedia.etcMediaList.length < 2){
        this.$log.debug('Media Level Result Mobile미디어 전처리 , 단일 모델 처리 (Y/F/S/E)');
        switch (this.mobileMedia.inte_ModelCode) {
          case 'Y':
            this.mobileMedia.resultMedia = this.mobileMedia.mediaList['Youtube'];
            break;
          case 'F':
            this.mobileMedia.resultMedia = this.mobileMedia.mediaList['Facebook'];
            break;
          case 'S':
            this.mobileMedia.resultMedia = this.mobileMedia.mediaList['SMR'];
            break;
          case 'E':
            this.mobileMedia.mediaList['Etc'] = this.mobileMedia.etcMediaList[0]; // 18.09.13
            this.mobileMedia.resultMedia = this.mobileMedia.mediaList['Etc'];
            break;
          default:
        }
        // Mobile매체 처리로직 종료
        this.calcMobileMedia();
      }else if(this.mobileMedia.overall !== null && this.mobileMedia.inte_ModelCode == ''){
        // Mobile매체 처리로직 종료
        this.$log.debug('Media Level Result Mobile미디어 전처리 , Overall 모델처리 , 채널(Y/F/S/E)없음');
        this.mobileMedia.resultMedia = this.mobileMedia.overall;
        this.calcMobileMedia();
      }else if(this.mobileMedia.overall !== null && this.mobileMedia.inte_ModelCode != ''){
        this.$log.debug('Media Level Result Mobile미디어 전처리 , Overall 모델처리 , 채널(Y/F/S/E)존재');
        this.calcMobileMedia();
      }else{
        this.calcMobileMedia();
      }
    },
    // index_2-3 Mobile미디어 통합리치 계산
    calcMobileMedia(){
      if(this.mobileMedia.inte_ModelCode.length > 1){
        switch(this.mobileMedia.inte_ModelCode) {
          case 'SY': // SMR Youtube , A2 Logic
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [SMR/Youtube]');
              this.mobileMedia.screenCount = 2;
              this.mobileMedia.reachA = this.mobileMedia.mediaList['Youtube'].reach1;
              this.mobileMedia.reachALabel = 'Youtube';
              this.mobileMedia.reachB = this.mobileMedia.mediaList['SMR'].reach1;
              this.mobileMedia.reachBLabel = 'SMR';
              // this.A2_Logic(this.mobileMedia, this.mobileMedia.mediaList['Youtube'], this.mobileMedia.mediaList['SMR'], 'A2_1', 'media');
              this.BN2_Logic(this.mobileMedia, this.mobileMedia.mediaList['Youtube'], this.mobileMedia.mediaList['SMR'], 'BN2_1');
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [YS] A2로직 reach1 : ' + this.mobileMedia.resultMedia.reach1);
              break;
          case 'FY': // Facebook Youbute , B Logic
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [Facebook/Youtube]');
              this.mobileMedia.screenCount = 2;
              this.mobileMedia.reachA = this.mobileMedia.mediaList['Facebook'].reach1;
              this.mobileMedia.reachALabel = 'Facebook';
              this.mobileMedia.reachB = this.mobileMedia.mediaList['Youtube'].reach1;
              this.mobileMedia.reachBLabel = 'Youtube';
              // this.B_Logic(this.mobileMedia, this.mobileMedia.mediaList['Facebook'], this.mobileMedia.mediaList['Youtube']);
              this.BN2_Logic(this.mobileMedia, this.mobileMedia.mediaList['Youtube'], this.mobileMedia.mediaList['Facebook'], 'BN2_2');
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [FY] B로직 reach1 : ' + this.mobileMedia.resultMedia.reach1);
              break;
          case 'EY': // 기타매체, Youtube , C Logic
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [기타매체/Youtube]');
              // this.C_Logic(this.mobileMedia, this.mobileMedia.mediaList['Youtube'], this.mobileMedia.mediaList['Etc']);
              this.CN_Logic(this.mobileMedia, this.mobileMedia.mediaList['Youtube'], this.mobileMedia.mediaList['Etc']);
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [YE] C로직 reach1 : ' + this.mobileMedia.resultMedia.reach1);
              this.mobileMedia.screenCount = 2;
              this.mobileMedia.reachA = this.mobileMedia.mediaList['Youtube'].reach1;
              this.mobileMedia.reachALabel = 'Youtube';
              this.mobileMedia.reachB = this.mobileMedia.mediaList['Etc'].reach1;
              this.mobileMedia.reachBLabel = 'Etc';
              break;
          case 'FS': // Facebook SMR , B Logic
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [Facebook/SMR]');
              this.mobileMedia.screenCount = 2;
              this.mobileMedia.reachA = this.mobileMedia.mediaList['Facebook'].reach1;
              this.mobileMedia.reachALabel = 'Facebook';
              this.mobileMedia.reachB = this.mobileMedia.mediaList['SMR'].reach1;
              this.mobileMedia.reachBLabel = 'SMR';
              // this.B_Logic(this.mobileMedia, this.mobileMedia.mediaList['Facebook'], this.mobileMedia.mediaList['SMR']);
              this.BN2_Logic(this.mobileMedia, this.mobileMedia.mediaList['SMR'], this.mobileMedia.mediaList['Facebook'], 'BN2_2');
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [FS] B로직 reach1 : ' + this.mobileMedia.resultMedia.reach1);
              break;
          case 'ES': // 기타매체 SMR , C Logic
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [기타매체/SMR]');
              this.mobileMedia.screenCount = 2;
              this.mobileMedia.reachA = this.mobileMedia.mediaList['SMR'].reach1;
              this.mobileMedia.reachALabel = 'SMR';
              this.mobileMedia.reachB = this.mobileMedia.mediaList['Etc'].reach1;
              this.mobileMedia.reachBLabel = 'Etc';
              // this.C_Logic(this.mobileMedia, this.mobileMedia.mediaList['SMR'], this.mobileMedia.mediaList['Etc']);
              this.CN_Logic(this.mobileMedia, this.mobileMedia.mediaList['SMR'], this.mobileMedia.mediaList['Etc']);
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [SE] C로직 reach1 : ' + this.mobileMedia.resultMedia.reach1);
              break;
          case 'EF': // 기타매체 Facebook , C Logic
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [기타매체/Facebook]');
              this.mobileMedia.screenCount = 2;
              this.mobileMedia.reachA = this.mobileMedia.mediaList['Facebook'].reach1;
              this.mobileMedia.reachALabel = 'Facebook';
              this.mobileMedia.reachB = this.mobileMedia.mediaList['Etc'].reach1;
              this.mobileMedia.reachBLabel = 'Etc';
              // this.C_Logic(this.mobileMedia, this.mobileMedia.mediaList['Facebook'], this.mobileMedia.mediaList['Etc']);
              this.CN_Logic(this.mobileMedia, this.mobileMedia.mediaList['Facebook'], this.mobileMedia.mediaList['Etc']);
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [FE] C로직 reach1 : ' + this.mobileMedia.resultMedia.reach1);
              break;
          case 'FSY': // Facebook SMR Youtube , A2 Logic - B Logic
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [Facebook/SMR/Youtube]');
              // this.A2_Logic(this.mobileMedia, this.mobileMedia.mediaList['Youtube'], this.mobileMedia.mediaList['SMR'], 'A2_1', 'media');
              this.BN2_Logic(this.mobileMedia, this.mobileMedia.mediaList['Youtube'], this.mobileMedia.mediaList['SMR'], 'BN2_1');
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [YS] A2로직 reach1 : ' + this.mobileMedia.resultMedia.reach1);
              var A2LogicChannel = this.$_.clone(this.mobileMedia.resultMedia);
              // [start 벤다이어그램용]
              this.mobileMedia.screenCount = 3;
              this.mobileMedia.reachA = this.mobileMedia.mediaList['Youtube'].reach1;
              this.mobileMedia.reachALabel = 'Youtube';
              this.mobileMedia.reachB = this.mobileMedia.mediaList['SMR'].reach1;
              this.mobileMedia.reachBLabel = 'SMR';
              this.mobileMedia.reachC = this.mobileMedia.mediaList['Facebook'].reach1;
              this.mobileMedia.reachCLabel = 'Facebook';

              this.mobileMedia.reachAB = this.mobileMedia.resultMedia.reach1;

              // this.B_Logic(this.mobileMedia, this.mobileMedia.mediaList['Facebook'], this.mobileMedia.mediaList['Youtube']);
              this.BN2_Logic(this.mobileMedia, this.mobileMedia.mediaList['Youtube'], this.mobileMedia.mediaList['Facebook'], 'BN2_2');
              this.mobileMedia.reachAC = this.mobileMedia.resultMedia.reach1;
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [FY] B로직 reach1 : ' + this.mobileMedia.reachAC);

              // this.B_Logic(this.mobileMedia, this.mobileMedia.mediaList['Facebook'], this.mobileMedia.mediaList['SMR']);
              this.BN2_Logic(this.mobileMedia, this.mobileMedia.mediaList['SMR'], this.mobileMedia.mediaList['Facebook'], 'BN2_2');
              this.mobileMedia.reachBC = this.mobileMedia.resultMedia.reach1;
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [FS] B로직 reach1 : ' + this.mobileMedia.reachBC);
              // [end   벤다이어그램용]
              // this.B_Logic(this.mobileMedia, this.mobileMedia.mediaList['Facebook'], A2LogicChannel);
              this.BN2_Logic(this.mobileMedia, A2LogicChannel, this.mobileMedia.mediaList['Facebook'], 'BN2_2');
              this.mobileMedia.reachABC = this.mobileMedia.resultMedia.reach1; // 밴다이어그램용
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [FYS] B로직 reach1 : ' + this.mobileMedia.reachABC);
              break;
          case 'EFY': // 기타매체 Facebook Youtube , C Logic - B Logic
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [기타매체/Facebook/Youtube]');
              // this.C_Logic(this.mobileMedia, this.mobileMedia.mediaList['Youtube'], this.mobileMedia.mediaList['Etc']);
              this.CN_Logic(this.mobileMedia, this.mobileMedia.mediaList['Youtube'], this.mobileMedia.mediaList['Etc']);
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [YE] C로직 reach1 : ' + this.mobileMedia.resultMedia.reach1);
              var CLogicChannel = this.$_.clone(this.mobileMedia.resultMedia);
              // [start 벤다이어그램용]
              this.mobileMedia.screenCount = 3;
              this.mobileMedia.reachA = this.mobileMedia.mediaList['Youtube'].reach1;
              this.mobileMedia.reachALabel = 'Youtube';
              this.mobileMedia.reachB = this.mobileMedia.mediaList['Etc'].reach1;
              this.mobileMedia.reachBLabel = 'Etc';
              this.mobileMedia.reachC = this.mobileMedia.mediaList['Facebook'].reach1;
              this.mobileMedia.reachCLabel = 'Facebook';

              this.mobileMedia.reachAB = this.mobileMedia.resultMedia.reach1;

              // this.B_Logic(this.mobileMedia, this.mobileMedia.mediaList['Facebook'], this.mobileMedia.mediaList['Youtube']);
              this.BN2_Logic(this.mobileMedia, this.mobileMedia.mediaList['Youtube'], this.mobileMedia.mediaList['Facebook'], 'BN2_2');
              this.mobileMedia.reachAC = this.mobileMedia.resultMedia.reach1;
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [FY] B로직 reach1 : ' + this.mobileMedia.reachAC);
              // this.C_Logic(this.mobileMedia, this.mobileMedia.mediaList['Facebook'], this.mobileMedia.mediaList['Etc']);
              this.CN_Logic(this.mobileMedia, this.mobileMedia.mediaList['Facebook'], this.mobileMedia.mediaList['Etc']);
              this.mobileMedia.reachBC = this.mobileMedia.resultMedia.reach1;
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [FE] C로직 reach1 : ' + this.mobileMedia.reachBC);
              // [end   벤다이어그램용]
              // this.B_Logic(this.mobileMedia, this.mobileMedia.mediaList['Facebook'], CLogicChannel);
              this.BN2_Logic(this.mobileMedia, CLogicChannel, this.mobileMedia.mediaList['Facebook'], 'BN2_2');
              this.mobileMedia.reachABC = this.mobileMedia.resultMedia.reach1; // 밴다이어그램용
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [FYE] C로직 reach1 : ' + this.mobileMedia.reachABC);
              break;
          case 'ESY': // 기타매체 SMR Youtube , A2 Logic - C Logic
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [기타매체/SMR/Youtube]');
              // this.A2_Logic(this.mobileMedia, this.mobileMedia.mediaList['Youtube'], this.mobileMedia.mediaList['SMR'], 'A2_1', 'media');
              this.BN2_Logic(this.mobileMedia, this.mobileMedia.mediaList['Youtube'], this.mobileMedia.mediaList['SMR'], 'BN2_1');
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [YS] A2로직 reach1 : ' + this.mobileMedia.resultMedia.reach1);
              var A2LogicChannel = this.$_.clone(this.mobileMedia.resultMedia);
              // [start 벤다이어그램용]
              this.mobileMedia.screenCount = 3;
              this.mobileMedia.reachA = this.mobileMedia.mediaList['Youtube'].reach1;
              this.mobileMedia.reachALabel = 'Youtube';
              this.mobileMedia.reachB = this.mobileMedia.mediaList['SMR'].reach1;
              this.mobileMedia.reachBLabel = 'SMR';
              this.mobileMedia.reachC = this.mobileMedia.mediaList['Etc'].reach1;
              this.mobileMedia.reachCLabel = 'Etc';

              this.mobileMedia.reachAB = this.mobileMedia.resultMedia.reach1;

              // this.C_Logic(this.mobileMedia, this.mobileMedia.mediaList['Youtube'], this.mobileMedia.mediaList['Etc']);
              this.CN_Logic(this.mobileMedia, this.mobileMedia.mediaList['Youtube'], this.mobileMedia.mediaList['Etc']);
              this.mobileMedia.reachAC = this.mobileMedia.resultMedia.reach1;
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [YE] C로직 reach1 : ' + this.mobileMedia.reachAC);

              // this.C_Logic(this.mobileMedia, this.mobileMedia.mediaList['SMR'], this.mobileMedia.mediaList['Etc']);
              this.CN_Logic(this.mobileMedia, this.mobileMedia.mediaList['SMR'], this.mobileMedia.mediaList['Etc']);
              this.mobileMedia.reachBC = this.mobileMedia.resultMedia.reach1;
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [SE] C로직 reach1 : ' + this.mobileMedia.reachBC);
              // [end   벤다이어그램용]
              // this.C_Logic(this.mobileMedia, A2LogicChannel, this.mobileMedia.mediaList['Etc']);
              this.CN_Logic(this.mobileMedia, A2LogicChannel, this.mobileMedia.mediaList['Etc']);
              this.mobileMedia.reachABC = this.mobileMedia.resultMedia.reach1; // 밴다이어그램용
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [YSE] C로직 reach1 : ' + this.mobileMedia.reachABC);
              break;
          case 'EFS': // 기타매체 Facebook SMR , C Logic - B Logic
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [기타매체/Facebook/SMR]');
              // this.C_Logic(this.mobileMedia, this.mobileMedia.mediaList['SMR'], this.mobileMedia.mediaList['Etc']);
              this.CN_Logic(this.mobileMedia, this.mobileMedia.mediaList['SMR'], this.mobileMedia.mediaList['Etc']);
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [SE] C로직 reach1 : ' + this.mobileMedia.resultMedia.reach1);
              var CLogicChannel = this.$_.clone(this.mobileMedia.resultMedia);
              // [start 벤다이어그램용]
              this.mobileMedia.screenCount = 3;
              this.mobileMedia.reachA = this.mobileMedia.mediaList['SMR'].reach1;
              this.mobileMedia.reachALabel = 'SMR';
              this.mobileMedia.reachB = this.mobileMedia.mediaList['Etc'].reach1;
              this.mobileMedia.reachBLabel = 'Etc';
              this.mobileMedia.reachC = this.mobileMedia.mediaList['Facebook'].reach1;
              this.mobileMedia.reachCLabel = 'Facebook';

              this.mobileMedia.reachAB = this.mobileMedia.resultMedia.reach1;

              // this.B_Logic(this.mobileMedia, this.mobileMedia.mediaList['Facebook'], this.mobileMedia.mediaList['SMR']);
              this.BN2_Logic(this.mobileMedia, this.mobileMedia.mediaList['SMR'], this.mobileMedia.mediaList['Facebook'], 'BN2_2');
              this.mobileMedia.reachAC = this.mobileMedia.resultMedia.reach1;
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [FS] B로직 reach1 : ' + this.mobileMedia.reachAC);

              // this.C_Logic(this.mobileMedia, this.mobileMedia.mediaList['Facebook'], this.mobileMedia.mediaList['Etc']);
              this.CN_Logic(this.mobileMedia, this.mobileMedia.mediaList['Facebook'], this.mobileMedia.mediaList['Etc']);
              this.mobileMedia.reachBC = this.mobileMedia.resultMedia.reach1;
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [FE] C로직 reach1 : ' + this.mobileMedia.reachBC);
              // [end   벤다이어그램용]
              // this.B_Logic(this.mobileMedia, this.mobileMedia.mediaList['Facebook'], CLogicChannel);
              this.BN2_Logic(this.mobileMedia, CLogicChannel, this.mobileMedia.mediaList['Facebook'], 'BN2_2');
              this.mobileMedia.reachABC = this.mobileMedia.resultMedia.reach1; // 밴다이어그램용
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [FSE] B로직 reach1 : ' + this.mobileMedia.reachABC);
              break;
          case 'EFSY': // A2 Logic - C Logic - B Logic
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [기타매체/Facebook/SMR/Youtube]');
              this.mobileMedia.screenCount = 4;
              // this.A2_Logic(this.mobileMedia, this.mobileMedia.mediaList['Youtube'], this.mobileMedia.mediaList['SMR'], 'A2_1', 'media');
              this.BN2_Logic(this.mobileMedia, this.mobileMedia.mediaList['Youtube'], this.mobileMedia.mediaList['SMR'], 'BN2_1');
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [YS] A2로직 reach1 : ' + this.mobileMedia.resultMedia.reach1);
              var A2LogicChannel = this.$_.clone(this.mobileMedia.resultMedia);
              // this.C_Logic(this.mobileMedia, A2LogicChannel, this.mobileMedia.mediaList['Etc']);
              this.CN_Logic(this.mobileMedia, A2LogicChannel, this.mobileMedia.mediaList['Etc']);
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [YSE] C로직 reach1 : ' + this.mobileMedia.resultMedia.reach1);
              var CLogicChannel = this.$_.clone(this.mobileMedia.resultMedia);
              // this.B_Logic(this.mobileMedia, this.mobileMedia.mediaList['Facebook'], CLogicChannel);
              this.BN2_Logic(this.mobileMedia, CLogicChannel, this.mobileMedia.mediaList['Facebook'], 'BN2_2');
              this.$log.debug('Media Level Result 통합리치 계산 Mobile [FYSE] B로직 reach1 : ' + this.mobileMedia.resultMedia.reach1);
              break;
        }
      }else if(this.mobileMedia.inte_ModelCode.length == 1){
        // Mobile GRPS 모델
      }else if(this.mobileMedia.overall !== null){
        // Mobile-overall GRPS 모델
      }
      // Mobile매체 처리로직 종료
      this.mediaProcessingFlag++;
    },
    // index_2-2 Digital미디어 통합리치 계산
    // index_2-2 Digital미디어 통합리치 계산
    calcDigitalMediaPreprocessing(){
      this.$log.debug('Media Level Result Digital미디어 전처리');
      this.$log.debug('Media Level Result Digital미디어 전처리 Inte Model Code : ' + this.digitalMedia.inte_ModelCode);
      // this.$log.debug('Media Level Result Digital미디어 전처리 기타매체 개수 : ' + this.digitalMedia.etcMediaList.length);
      if(this.digitalMedia.inte_ModelCode.length > 1 || this.digitalMedia.etcMediaList.length > 1){
        // 먼저 기타매체 처리로직
        // 기타매체가 한개냐 둘이상이냐에 따라 로직이 달라짐
        if(this.digitalMedia.etcMediaList.length > 1){
          this.$log.debug('Media Level Result Digital미디어 전처리 기타매체 개수 : ' + this.digitalMedia.etcMediaList.length);
          // C2 Logic 적용
          var maxReach = 0;
          var inteReach = 0;
          var queryParams = [];

          for(var i=0; i<this.digitalMedia.etcMediaList.length; i++){
            inteReach += parseFloat(this.digitalMedia.etcMediaList[i].reach1);
            if(this.digitalMedia.etcMediaList[i].reach1 > maxReach){
              maxReach = this.digitalMedia.etcMediaList[i].reach1;
            }
            queryParams.push(this.$_.clone(this.digitalMedia.etcMediaList[i])); // 0번째 미디어 통합 계수를 위해서
          }
          // 파라미터 만들기 Digital overall;
          queryParams[0].channel = 'overall';
          // 계수 읽어오기
          var token = sessionStorage.getItem("myToken");
          var param = encodeURI(JSON.stringify(queryParams));
          this.$http.post('/api/select/cffcntBetaRegression?access_token='+token+'&objs='+param)
            .then((result) => {
              var inteGRP = 0;
              var cffcnt = result.data[0];
              for(var i=0; i <result.data.length; i++){
                inteGRP += this.clacSudoGRPs(cffcnt, this.digitalMedia.etcMediaList[i].reach1);
              }

              result.data[0].reach1 = this.calculationReach(result.data[0], inteGRP);
              result.data[0].grps = inteGRP;

              if(result.data[0].reach1 > maxReach && result.data[0].reach1 < inteReach){
              }else{
                if(result.data[0].reach1 <= maxReach){
                  result.data[0].reach1 = maxReach;
                }else if(result.data[0].reach1 >= inteReach){
                  result.data[0].reach1 = inteReach;
                }
              }
              this.digitalMedia.mediaList['Etc'] = result.data[0];

              this.$log.debug('Media Level Result Digital미디어 전처리 기타매체 통합리치 : ' + this.digitalMedia.mediaList['Etc'].reach1);
              this.digitalMedia.resultMedia = this.digitalMedia.mediaList['Etc'];
              this.digitalMedia.resultMedia.target_cnt = this.digitalMedia.etcMediaList[0].target_cnt; // 18.11.23
              this.calcdigitalMedia();
            });
        }else if(this.digitalMedia.etcMediaList.length == 1){
          this.digitalMedia.mediaList['Etc'] = this.digitalMedia.etcMediaList[0];
          this.calcdigitalMedia();
        }else{ // 기타 매체가 없을 경우
          this.calcdigitalMedia();
        }

      }else if(this.digitalMedia.inte_ModelCode.length == 1 && this.digitalMedia.etcMediaList.length < 2){
        this.$log.debug('Media Level Result Digital미디어 전처리 , 단일 모델 처리 (Y/F/S/E)');
        switch (this.digitalMedia.inte_ModelCode) {
          case 'Y':
            this.digitalMedia.resultMedia = this.digitalMedia.mediaList['Youtube'];
            break;
          case 'F':
            this.digitalMedia.resultMedia = this.digitalMedia.mediaList['Facebook'];
            break;
          case 'S':
            this.digitalMedia.resultMedia = this.digitalMedia.mediaList['SMR'];
            break;
          case 'E':
            this.digitalMedia.mediaList['Etc'] = this.digitalMedia.etcMediaList[0]; // 18.09.13
            this.digitalMedia.resultMedia = this.digitalMedia.mediaList['Etc'];
            break;
          default:
        }
        // Digital매체 처리로직 종료
        this.calcdigitalMedia();
      }else if(this.digitalMedia.overall !== null && this.digitalMedia.inte_ModelCode == ''){
        this.$log.debug('Media Level Result Digital미디어 전처리 , Overall 모델처리 , 채널(Y/F/S/E)없음');
        this.digitalMedia.resultMedia = this.digitalMedia.overall;
        this.calcdigitalMedia();
      }else if(this.digitalMedia.overall !== null && this.digitalMedia.inte_ModelCode != ''){
        this.$log.debug('Media Level Result Digital미디어 전처리 , Overall 모델처리 , 채널(Y/F/S/E)존재');
        this.calcdigitalMedia();
      }else{
        this.calcdigitalMedia();
      }
    },
    // index_2-2 Digital미디어 통합리치 계산
    calcdigitalMedia(){
      if(this.digitalMedia.inte_ModelCode.length > 1){
        switch(this.digitalMedia.inte_ModelCode) {
          case 'SY': // SMR Youtube , A2 Logic
              this.$log.debug('Media Level Result 통합리치 계산 Digital [SMR/Youtube]');
              this.digitalMedia.screenCount = 2;
              this.digitalMedia.reachA = this.digitalMedia.mediaList['Youtube'].reach1;
              this.digitalMedia.reachALabel = 'Youtube';
              this.digitalMedia.reachB = this.digitalMedia.mediaList['SMR'].reach1;
              this.digitalMedia.reachBLabel = 'SMR';
              // this.A2_Logic(this.digitalMedia, this.digitalMedia.mediaList['Youtube'], this.digitalMedia.mediaList['SMR'], 'A2_1', 'media');
              this.BN2_Logic(this.digitalMedia, this.digitalMedia.mediaList['Youtube'], this.digitalMedia.mediaList['SMR'], 'BN2_1');
              this.$log.debug('Media Level Result 통합리치 계산 Digital [YS] A2로직 reach1 : ' + this.digitalMedia.resultMedia.reach1);
              break;
          case 'FY': // Facebook Youbute , B Logic
              this.$log.debug('Media Level Result 통합리치 계산 Digital [Facebook/Youtube]');
              this.digitalMedia.screenCount = 2;
              this.digitalMedia.reachA = this.digitalMedia.mediaList['Facebook'].reach1;
              this.digitalMedia.reachALabel = 'Facebook';
              this.digitalMedia.reachB = this.digitalMedia.mediaList['Youtube'].reach1;
              this.digitalMedia.reachBLabel = 'Youtube';
              // this.B_Logic(this.digitalMedia, this.digitalMedia.mediaList['Facebook'], this.digitalMedia.mediaList['Youtube']);
              this.BN2_Logic(this.digitalMedia, this.digitalMedia.mediaList['Youtube'], this.digitalMedia.mediaList['Facebook'], 'BN2_2');
              this.$log.debug('Media Level Result 통합리치 계산 Digital [FY] B로직 reach1 : ' + this.digitalMedia.resultMedia.reach1);
              break;
          case 'EY': // 기타매체, Youtube , C Logic
              this.$log.debug('Media Level Result 통합리치 계산 Digital [기타매체/Youtube]');
              // this.C_Logic(this.digitalMedia, this.digitalMedia.mediaList['Youtube'], this.digitalMedia.mediaList['Etc']);
              this.CN_Logic(this.digitalMedia, this.digitalMedia.mediaList['Youtube'], this.digitalMedia.mediaList['Etc']);
              this.$log.debug('Media Level Result 통합리치 계산 Digital [YE] C로직 reach1 : ' + this.digitalMedia.resultMedia.reach1);
              this.digitalMedia.screenCount = 2;
              this.digitalMedia.reachA = this.digitalMedia.mediaList['Youtube'].reach1;
              this.digitalMedia.reachALabel = 'Youtube';
              this.digitalMedia.reachB = this.digitalMedia.mediaList['Etc'].reach1;
              this.digitalMedia.reachBLabel = 'Etc';

              break;
          case 'FS': // Facebook SMR , B Logic
              this.$log.debug('Media Level Result 통합리치 계산 Digital [Facebook/SMR]');
              this.digitalMedia.screenCount = 2;
              this.digitalMedia.reachA = this.digitalMedia.mediaList['Facebook'].reach1;
              this.digitalMedia.reachALabel = 'Facebook';
              this.digitalMedia.reachB = this.digitalMedia.mediaList['SMR'].reach1;
              this.digitalMedia.reachBLabel = 'SMR';
              // this.B_Logic(this.digitalMedia, this.digitalMedia.mediaList['Facebook'], this.digitalMedia.mediaList['SMR']);
              this.BN2_Logic(this.digitalMedia, this.digitalMedia.mediaList['SMR'], this.digitalMedia.mediaList['Facebook'], 'BN2_2');
              this.$log.debug('Media Level Result 통합리치 계산 Digital [FS] B로직 reach1 : ' + this.digitalMedia.resultMedia.reach1);
              break;
          case 'ES': // 기타매체 SMR , C Logic
              this.$log.debug('Media Level Result 통합리치 계산 Digital [기타매체/SMR]');
              this.digitalMedia.screenCount = 2;
              this.digitalMedia.reachA = this.digitalMedia.mediaList['SMR'].reach1;
              this.digitalMedia.reachALabel = 'SMR';
              this.digitalMedia.reachB = this.digitalMedia.mediaList['Etc'].reach1;
              this.digitalMedia.reachBLabel = 'Etc';
              // this.C_Logic(this.digitalMedia, this.digitalMedia.mediaList['SMR'], this.digitalMedia.mediaList['Etc']);
              this.CN_Logic(this.digitalMedia, this.digitalMedia.mediaList['SMR'], this.digitalMedia.mediaList['Etc']);
              this.$log.debug('Media Level Result 통합리치 계산 Digital [SE] C로직 reach1 : ' + this.digitalMedia.resultMedia.reach1);
              break;
          case 'EF': // 기타매체 Facebook , C Logic
              this.$log.debug('Media Level Result 통합리치 계산 Digital [기타매체/Facebook]');
              this.digitalMedia.screenCount = 2;
              this.digitalMedia.reachA = this.digitalMedia.mediaList['Facebook'].reach1;
              this.digitalMedia.reachALabel = 'Facebook';
              this.digitalMedia.reachB = this.digitalMedia.mediaList['Etc'].reach1;
              this.digitalMedia.reachBLabel = 'Etc';
              // this.C_Logic(this.digitalMedia, this.digitalMedia.mediaList['Facebook'], this.digitalMedia.mediaList['Etc']);
              this.CN_Logic(this.digitalMedia, this.digitalMedia.mediaList['Facebook'], this.digitalMedia.mediaList['Etc']);
              this.$log.debug('Media Level Result 통합리치 계산 Digital [FE] C로직 reach1 : ' + this.digitalMedia.resultMedia.reach1);
              break;
          case 'FSY': // Facebook SMR Youtube , A2 Logic - B Logic
              this.$log.debug('Media Level Result 통합리치 계산 Digital [Facebook/SMR/Youtube]');
              // this.A2_Logic(this.digitalMedia, this.digitalMedia.mediaList['Youtube'], this.digitalMedia.mediaList['SMR'], 'A2_1', 'media');
              this.BN2_Logic(this.digitalMedia, this.digitalMedia.mediaList['Youtube'], this.digitalMedia.mediaList['SMR'], 'BN2_1');
              this.$log.debug('Media Level Result 통합리치 계산 Digital [YS] A2로직 reach1 : ' + this.digitalMedia.resultMedia.reach1);
              var A2LogicChannel = this.$_.clone(this.digitalMedia.resultMedia);
              // [start 벤다이어그램용]
              this.digitalMedia.screenCount = 3;
              this.digitalMedia.reachA = this.digitalMedia.mediaList['Youtube'].reach1;
              this.digitalMedia.reachALabel = 'Youtube';
              this.digitalMedia.reachB = this.digitalMedia.mediaList['SMR'].reach1;
              this.digitalMedia.reachBLabel = 'SMR';
              this.digitalMedia.reachC = this.digitalMedia.mediaList['Facebook'].reach1;
              this.digitalMedia.reachCLabel = 'Facebook';

              this.digitalMedia.reachAB = this.digitalMedia.resultMedia.reach1;

              // this.B_Logic(this.digitalMedia, this.digitalMedia.mediaList['Facebook'], this.digitalMedia.mediaList['Youtube']);
              this.BN2_Logic(this.digitalMedia, this.digitalMedia.mediaList['Youtube'], this.digitalMedia.mediaList['Facebook'], 'BN2_2');
              this.digitalMedia.reachAC = this.digitalMedia.resultMedia.reach1;
              this.$log.debug('Media Level Result 통합리치 계산 Digital [FY] B로직 reach1 : ' + this.digitalMedia.reachAC);

              // this.B_Logic(this.digitalMedia, this.digitalMedia.mediaList['Facebook'], this.digitalMedia.mediaList['SMR']);
              this.BN2_Logic(this.digitalMedia, this.digitalMedia.mediaList['SMR'], this.digitalMedia.mediaList['Facebook'], 'BN2_2');
              this.digitalMedia.reachBC = this.digitalMedia.resultMedia.reach1;
              this.$log.debug('Media Level Result 통합리치 계산 Digital [FS] B로직 reach1 : ' + this.digitalMedia.reachBC);
              // [end   벤다이어그램용]
              // this.B_Logic(this.digitalMedia, this.digitalMedia.mediaList['Facebook'], A2LogicChannel);
              this.BN2_Logic(this.digitalMedia, A2LogicChannel, this.digitalMedia.mediaList['Facebook'], 'BN2_2');
              this.digitalMedia.reachABC = this.digitalMedia.resultMedia.reach1; // 밴다이어그램용
              this.$log.debug('Media Level Result 통합리치 계산 Digital [FYS] B로직 reach1 : ' + this.digitalMedia.reachABC);

              break;
          case 'EFY': // 기타매체 Facebook Youtube , C Logic - B Logic
              this.$log.debug('Media Level Result 통합리치 계산 Digital [기타매체/Facebook/Youtube]');
              // this.C_Logic(this.digitalMedia, this.digitalMedia.mediaList['Youtube'], this.digitalMedia.mediaList['Etc']);
              this.CN_Logic(this.digitalMedia, this.digitalMedia.mediaList['Youtube'], this.digitalMedia.mediaList['Etc']);
              this.$log.debug('Media Level Result 통합리치 계산 Digital [YE] C로직 reach1 : ' + this.digitalMedia.resultMedia.reach1);
              var CLogicChannel = this.$_.clone(this.digitalMedia.resultMedia);
              // [start 벤다이어그램용]
              this.digitalMedia.screenCount = 3;
              this.digitalMedia.reachA = this.digitalMedia.mediaList['Youtube'].reach1;
              this.digitalMedia.reachALabel = 'Youtube';
              this.digitalMedia.reachB = this.digitalMedia.mediaList['Etc'].reach1;
              this.digitalMedia.reachBLabel = 'Etc';
              this.digitalMedia.reachC = this.digitalMedia.mediaList['Facebook'].reach1;
              this.digitalMedia.reachCLabel = 'Facebook';

              this.digitalMedia.reachAB = this.digitalMedia.resultMedia.reach1;

              // this.B_Logic(this.digitalMedia, this.digitalMedia.mediaList['Facebook'], this.digitalMedia.mediaList['Youtube']);
              this.BN2_Logic(this.digitalMedia, this.digitalMedia.mediaList['Youtube'], this.digitalMedia.mediaList['Facebook'], 'BN2_2');
              this.digitalMedia.reachAC = this.digitalMedia.resultMedia.reach1;
              this.$log.debug('Media Level Result 통합리치 계산 Digital [FY] B로직 reach1 : ' + this.digitalMedia.reachAC);

              // this.C_Logic(this.digitalMedia, this.digitalMedia.mediaList['Facebook'], this.digitalMedia.mediaList['Etc']);
              this.CN_Logic(this.digitalMedia, this.digitalMedia.mediaList['Facebook'], this.digitalMedia.mediaList['Etc']);
              this.digitalMedia.reachBC = this.digitalMedia.resultMedia.reach1;
              this.$log.debug('Media Level Result 통합리치 계산 Digital [FE] C로직 reach1 : ' + this.digitalMedia.reachBC);
              // [end   벤다이어그램용]
              // this.B_Logic(this.digitalMedia, this.digitalMedia.mediaList['Facebook'], CLogicChannel);
              this.BN2_Logic(this.digitalMedia, CLogicChannel, this.digitalMedia.mediaList['Facebook'], 'BN2_2');
              this.digitalMedia.reachABC = this.digitalMedia.resultMedia.reach1; // 밴다이어그램용
              this.$log.debug('Media Level Result 통합리치 계산 Digital [FYE] C로직 reach1 : ' + this.digitalMedia.reachABC);
              break;
          case 'ESY': // 기타매체 SMR Youtube , A2 Logic - C Logic
              this.$log.debug('Media Level Result 통합리치 계산 Digital [기타매체/SMR/Youtube]');
              // this.A2_Logic(this.digitalMedia, this.digitalMedia.mediaList['Youtube'], this.digitalMedia.mediaList['SMR'], 'A2_1', 'media');
              this.BN2_Logic(this.digitalMedia, this.digitalMedia.mediaList['Youtube'], this.digitalMedia.mediaList['SMR'], 'BN2_1');
              this.$log.debug('Media Level Result 통합리치 계산 Digital [YS] A2로직 reach1 : ' + this.digitalMedia.resultMedia.reach1);
              var A2LogicChannel = this.$_.clone(this.digitalMedia.resultMedia);
              // [start 벤다이어그램용]
              this.digitalMedia.screenCount = 3;
              this.digitalMedia.reachA = this.digitalMedia.mediaList['Youtube'].reach1;
              this.digitalMedia.reachALabel = 'Youtube';
              this.digitalMedia.reachB = this.digitalMedia.mediaList['SMR'].reach1;
              this.digitalMedia.reachBLabel = 'SMR';
              this.digitalMedia.reachC = this.digitalMedia.mediaList['Etc'].reach1;
              this.digitalMedia.reachCLabel = 'Etc';

              this.digitalMedia.reachAB = this.digitalMedia.resultMedia.reach1;

              // this.C_Logic(this.digitalMedia, this.digitalMedia.mediaList['Youtube'], this.digitalMedia.mediaList['Etc']);
              this.CN_Logic(this.digitalMedia, this.digitalMedia.mediaList['Youtube'], this.digitalMedia.mediaList['Etc']);
              this.digitalMedia.reachAC = this.digitalMedia.resultMedia.reach1;
              this.$log.debug('Media Level Result 통합리치 계산 Digital [YE] C로직 reach1 : ' + this.digitalMedia.reachAC);

              // this.C_Logic(this.digitalMedia, this.digitalMedia.mediaList['SMR'], this.digitalMedia.mediaList['Etc']);
              this.CN_Logic(this.digitalMedia, this.digitalMedia.mediaList['SMR'], this.digitalMedia.mediaList['Etc']);
              this.digitalMedia.reachBC = this.digitalMedia.resultMedia.reach1;
              this.$log.debug('Media Level Result 통합리치 계산 Digital [SE] C로직 reach1 : ' + this.digitalMedia.reachBC);
              // [end   벤다이어그램용]
              // this.C_Logic(this.digitalMedia, A2LogicChannel, this.digitalMedia.mediaList['Etc']);
              this.CN_Logic(this.digitalMedia, A2LogicChannel, this.digitalMedia.mediaList['Etc']);
              this.digitalMedia.reachABC = this.digitalMedia.resultMedia.reach1; // 밴다이어그램용
              this.$log.debug('Media Level Result 통합리치 계산 Digital [YSE] C로직 reach1 : ' + this.digitalMedia.reachABC);
              break;
          case 'EFS': // 기타매체 Facebook SMR , C Logic - B Logic
              this.$log.debug('Media Level Result 통합리치 계산 Digital [기타매체/Facebook/SMR]');
              // this.C_Logic(this.digitalMedia, this.digitalMedia.mediaList['SMR'], this.digitalMedia.mediaList['Etc']);
              this.CN_Logic(this.digitalMedia, this.digitalMedia.mediaList['SMR'], this.digitalMedia.mediaList['Etc']);
              this.$log.debug('Media Level Result 통합리치 계산 Digital [SE] C로직 reach1 : ' + this.digitalMedia.resultMedia.reach1);
              var CLogicChannel = this.$_.clone(this.digitalMedia.resultMedia);
              // [start 벤다이어그램용]
              this.digitalMedia.screenCount = 3;
              this.digitalMedia.reachA = this.digitalMedia.mediaList['SMR'].reach1;
              this.digitalMedia.reachALabel = 'SMR';
              this.digitalMedia.reachB = this.digitalMedia.mediaList['Etc'].reach1;
              this.digitalMedia.reachBLabel = 'Etc';
              this.digitalMedia.reachC = this.digitalMedia.mediaList['Facebook'].reach1;
              this.digitalMedia.reachCLabel = 'Facebook';

              this.digitalMedia.reachAB = this.digitalMedia.resultMedia.reach1;

              // this.B_Logic(this.digitalMedia, this.digitalMedia.mediaList['Facebook'], this.digitalMedia.mediaList['SMR']);
              this.BN2_Logic(this.digitalMedia, this.digitalMedia.mediaList['SMR'], this.digitalMedia.mediaList['Facebook'], 'BN2_2');
              this.digitalMedia.reachAC = this.digitalMedia.resultMedia.reach1;
              this.$log.debug('Media Level Result 통합리치 계산 Digital [FS] B로직 reach1 : ' + this.digitalMedia.reachAC);

              // this.C_Logic(this.digitalMedia, this.digitalMedia.mediaList['Facebook'], this.digitalMedia.mediaList['Etc']);
              this.CN_Logic(this.digitalMedia, this.digitalMedia.mediaList['Facebook'], this.digitalMedia.mediaList['Etc']);
              this.digitalMedia.reachBC = this.digitalMedia.resultMedia.reach1;
              this.$log.debug('Media Level Result 통합리치 계산 Digital [FE] C로직 reach1 : ' + this.digitalMedia.reachBC);
              // [end   벤다이어그램용]
              // this.B_Logic(this.digitalMedia, this.digitalMedia.mediaList['Facebook'], CLogicChannel);
              this.BN2_Logic(this.digitalMedia, CLogicChannel, this.digitalMedia.mediaList['Facebook'], 'BN2_2');
              this.digitalMedia.reachABC = this.digitalMedia.resultMedia.reach1; // 밴다이어그램용
              this.$log.debug('Media Level Result 통합리치 계산 Digital [FSE] B로직 reach1 : ' + this.digitalMedia.reachABC);
              break;
          case 'EFSY': // A2 Logic - C Logic - B Logic
              this.$log.debug('Media Level Result 통합리치 계산 Digital [기타매체/Facebook/SMR/Youtube]');
              this.digitalMedia.screenCount = 4;
              // this.A2_Logic(this.digitalMedia, this.digitalMedia.mediaList['Youtube'], this.digitalMedia.mediaList['SMR'], 'A2_1', 'media');
              this.BN2_Logic(this.digitalMedia, this.digitalMedia.mediaList['Youtube'], this.digitalMedia.mediaList['SMR'], 'BN2_1');
              this.$log.debug('Media Level Result 통합리치 계산 Digital [YS] A2로직 reach1 : ' + this.digitalMedia.resultMedia.reach1);
              var A2LogicChannel = this.$_.clone(this.digitalMedia.resultMedia);
              // this.C_Logic(this.digitalMedia, A2LogicChannel, this.digitalMedia.mediaList['Etc']);
              this.CN_Logic(this.digitalMedia, A2LogicChannel, this.digitalMedia.mediaList['Etc']);
              this.$log.debug('Media Level Result 통합리치 계산 Digital [YSE] C로직 reach1 : ' + this.digitalMedia.resultMedia.reach1);
              var CLogicChannel = this.$_.clone(this.digitalMedia.resultMedia);
              // this.B_Logic(this.digitalMedia, this.digitalMedia.mediaList['Facebook'], CLogicChannel);
              this.BN2_Logic(this.digitalMedia, CLogicChannel, this.digitalMedia.mediaList['Facebook'], 'BN2_2');
              this.$log.debug('Media Level Result 통합리치 계산 Digital [FYSE] B로직 reach1 : ' + this.digitalMedia.resultMedia.reach1);
              break;
        }
      }else if(this.digitalMedia.inte_ModelCode.length == 1){
      }else if(this.digitalMedia.overall !== null){
        // Digital-overall GRPS 모델
      }
      // Digital매체 처리로직 종료
      this.mediaProcessingFlag++;
    },
    calculationReach(cffcnt, grps){
      grps = parseFloat(grps);
      var z = (
        cffcnt.a +
        cffcnt.b1 * Math.log(grps) +
        cffcnt.b2 * Math.pow(Math.log(grps),2) +
        cffcnt.b3 * Math.pow(Math.log(grps),3)
      );
      var z2 = 1 + Math.exp(-z);
      var result = (cffcnt.lmt/z2) * 100;
      return result;
    },
    BN2_Logic(mediaTemplate, mediaA, mediaB, int_cffcnt_CD){
      var mediaABReach =  parseFloat(mediaA.reach1) +  parseFloat(mediaB.reach1);
      var maxReach = Math.max(mediaA.reach1, mediaB.reach1);
      var minReach = Math.min(mediaA.reach1, mediaB.reach1);
      var inteGRP  = parseFloat(mediaA.grps) + parseFloat(mediaB.grps);
      var maxReachMediaInfo = this.$_.clone(mediaA);

      // var inteReach = this.BN2_calc(mediaA, mediaB, int_cffcnt_CD);
      var bn2Result = this.BN2_calc(mediaA, mediaB, int_cffcnt_CD);
      if(bn2Result > minReach){
        bn2Result = minReach;
      }
      var inteReach = mediaABReach - bn2Result;

      if(inteReach <= maxReach){
        inteReach = maxReach;
      }else if(inteReach >=  mediaABReach){
        inteReach = mediaABReach;
      }

      maxReachMediaInfo.reach1 = inteReach;
      maxReachMediaInfo.grps = inteGRP;
      this.$log.debug('Media Logic Level Result BN2 Logic 최종 reach1 : ' + maxReachMediaInfo.reach1);
      mediaTemplate.resultMedia = maxReachMediaInfo;
    },
    BN2_calc(mediaA, mediaB, int_cffcnt_CD){
      // var mediaABReach =  parseFloat(mediaA.reach1) +  parseFloat(mediaB.reach1);
      var cffcnt = this.inte_cffcnt_N[int_cffcnt_CD];
      var z1 = Math.log((mediaA.reach1/100)/(cffcnt.ca-mediaB.reach1/100))*cffcnt.ba
      var z2 = Math.log((mediaB.reach1/100)/(cffcnt.cb-mediaB.reach1/100))*cffcnt.bb
      var z3 = cffcnt.cint / (1+Math.exp((cffcnt.a + (z1 + z2))*-1));
      return z3*100; // 중복노출값
    },
    BN3_Logic(mediaTemplate, mediaA, mediaB, mediaC, int_cffcnt_CD, gubun){
      var mediaABCReach =  parseFloat(mediaA.reach1) + parseFloat(mediaB.reach1) + parseFloat(mediaC.reach1);
      var inteGRP  = parseFloat(mediaA.grps) + parseFloat(mediaB.grps) + parseFloat(mediaC.grps);
      var maxReachMediaInfo = this.$_.clone(mediaA);
      var maxReach = Math.max(mediaA.reach1, mediaB.reach1, mediaC.reach1);
      var minReach = Math.min(mediaA.reach1, mediaB.reach1, mediaC.reach1);

      var tmp1 = 0.0;
      var tmp2 = 0.0;
      var tmp3 = 0.0;
      if(gubun == 'media') { // TV PC MO
        tmp1 = this.BN2_calc(mediaA, mediaB, 'BN2_8');
        tmp2 = this.BN2_calc(mediaA, mediaC, 'BN2_9');
        tmp3 = this.BN2_calc(mediaC, mediaB, 'BN2_7');
      } else { // 지 종 케
        tmp1 = this.BN2_calc(mediaA, mediaB, 'BN2_4');
        tmp2 = this.BN2_calc(mediaA, mediaC, 'BN2_3');
        tmp3 = this.BN2_calc(mediaC, mediaB, 'BN2_5');
      }
      var tmp4 = this.BN3_calc(mediaA, mediaB, mediaC, int_cffcnt_CD);
      if(tmp4 > minReach){
        tmp4 = minReach;
      }
      // var tmp4 = mediaABCReach - bn3Result;

      var inteReach = mediaABCReach - (tmp1 + tmp2 + tmp3) + tmp4;

      maxReachMediaInfo.grps = inteGRP;
      // 판별식 추가해야함.
      if(inteReach > maxReach && inteReach < mediaABCReach){
        maxReachMediaInfo.reach1 = inteReach;
      }else if(inteReach <= maxReach){
        maxReachMediaInfo.reach1 = maxReach;
      }else if(inteReach >= mediaABCReach){
        maxReachMediaInfo.reach1 = mediaABCReach;
      }

      this.$log.debug('Media Logic Level Result BN3 Logic 최종 reach1 : ' + maxReachMediaInfo.reach1);
      mediaTemplate.resultMedia = maxReachMediaInfo;
    },
    BN3_calc(mediaA, mediaB, mediaC, int_cffcnt_CD){
      // var mediaABCReach =  parseFloat(mediaA.reach1) + parseFloat(mediaB.reach1) + parseFloat(mediaC.reach1);
      var cffcnt = this.inte_cffcnt_N[int_cffcnt_CD];
      var z1 = Math.log((mediaA.reach1/100)/(cffcnt.ca-mediaB.reach1/100))*cffcnt.ba
      var z2 = Math.log((mediaB.reach1/100)/(cffcnt.cb-mediaB.reach1/100))*cffcnt.bb
      var z3 = Math.log((mediaC.reach1/100)/(cffcnt.cc-mediaC.reach1/100))*cffcnt.bc
      var z4 = cffcnt.cint / (1+Math.exp((cffcnt.a + (z1 + z2 + z3))*-1));
      return z4*100; // 중복노출값
    },
    // index_3-4 E Logic // E로직 추가 2018-10-10
    CN_Logic(mediaTemplate, channelA, channelB){
      this.$log.debug('Media Logic Level Result E Logic 시작');
      var maxReach = 0;
      var inteReach = channelA.reach1 + channelB.reach1;
      var queryParams = [];
      maxReach = channelA.reach1>=channelB.reach1?channelA.reach1:channelB.reach1;
      queryParams.push(this.$_.clone(channelA));
      queryParams.push(this.$_.clone(channelB));

      queryParams[0].channel = 'overall';
      queryParams[0].vehicle = 'overall'; // 2019.12.13 비히클이 overall 아니라 비히클 이 들어가잇는경우 가발생하므로 추가..

      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(queryParams));
      var domain =  this.$store.getters.getAPIDomain;
      var self = this;

      $.ajax({
           type: 'POST',
           url: domain +'/api/select/cffcntBetaRegression',
           data: 'access_token='+token+'&objs='+param,
           async: false,
           success: function(data) {
                if(data != null) {
                  var inteGRP = 0;
                  var inteGRPorigin = 0; // 2019.12.13
                  var cffcnt  = data[0];

                  for(var i=0; i <data.length; i++){
                    inteGRPorigin += parseFloat(queryParams[i].grps); // 2019.12.13
                    inteGRP += self.clacSudoGRPs(cffcnt, queryParams[i].reach1);
                  }

                  data[0].reach1 = self.calculationReach(data[0], inteGRP);
                  // data[0].grps = inteGRP;
                  data[0].grps = inteGRPorigin; // 2019.12.13

                  if(data[0].reach1 > maxReach && data[0].reach1 < inteReach){
                  }else{
                    if(data[0].reach1 <= maxReach){
                      data[0].reach1 = maxReach;
                    }else if(data[0].reach1 >= inteReach){
                      data[0].reach1 = inteReach;
                    }
                  }
                  mediaTemplate.resultMedia = self.$_.clone(data[0]);
                }
             }
        });
      this.$log.debug(mediaTemplate.resultMedia);
      this.$log.debug('Media Logic Level Result E Logic 최종 reach1 : ' + mediaTemplate.resultMedia.reach1);
    },
    digital_Inte_Logic(mediaTemplate, media1, media2){ // media1:digital , media2:PC, Mobile
      this.$log.debug('Media Logic Level Result PD+MO+Digital Inte. Logic 시작');
      // media1 : 디지털 , media2 : PC OR Mobile
      media1.reach1 = parseFloat(media1.reach1);
      media2.reach1 = parseFloat(media2.reach1);
      media1.grps = parseFloat(media1.grps);
      media2.grps = parseFloat(media2.grps);

      var queryParams = [];
      queryParams[0] = this.$_.clone(media1);
      queryParams[0].channel = 'overall';
      queryParams[0].vehicle = 'overall';
      queryParams[1] = this.$_.clone(media2); // 2018-10-26
      queryParams[1].channel = 'overall'; // 2018-10-26
      queryParams[1].vehicle = 'overall';

      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(queryParams));
      var domain =  this.$store.getters.getAPIDomain;
      var self = this;

      $.ajax({
           type: 'POST',
           url: domain +'/api/select/cffcntBetaRegression',
           data: 'access_token='+token+'&objs='+param,
           async: false,
           success: function(data) {
                if(data != null) {
                  // var a = data[0].
                  var goalReachMedia_2 = media2.reach1;
                  var incrementMedia_2_GRPs = 1;
                  var incrementRatioMedia_2 = media2.reach1 * 0.03;
                  var reachMinusRatioMedia_2 = 1;

                  var goalReachMedia_1 = media1.reach1;
                  var incrementMedia_1_GRPs = 1;
                  var incrementRatioMedia_1 = media1.reach1 * 0.03;
                  var reachMinusRatioMedia_1 = 1;

                  var Media2Finish = false;
                  var Media1Finish = false;
                  var originalInteGRPs = media1.grps + media2.grps ;

                  ////////////////////////////////////////////////////////////
                  for(var i=0; i<1000; i++){ // 100번안에 무조건 끝나는 로직 아닌가? 확인후 최대 루프수 변경
                    var reach1Media_2 = self.calculationReach(data[1], incrementMedia_2_GRPs);
                    reachMinusRatioMedia_2 = ( goalReachMedia_2 - reach1Media_2 ) / goalReachMedia_2;

                    if(reachMinusRatioMedia_2 < 0.0001){ // or 0.01
                      Media2Finish = true;
                    }else{
                      incrementMedia_2_GRPs = incrementMedia_2_GRPs * (reachMinusRatioMedia_2 * incrementRatioMedia_2 + 1);
                    }
                    ////////////////////////////////////////////////////////////
                    var reach1Media_1 = self.calculationReach(data[0], incrementMedia_1_GRPs);

                    reachMinusRatioMedia_1 = ( goalReachMedia_1 - reach1Media_1 ) / goalReachMedia_1;

                    if(reachMinusRatioMedia_1 < 0.0001){ // or 0.01
                      Media1Finish = true;
                    }else{
                      incrementMedia_1_GRPs = incrementMedia_1_GRPs * (reachMinusRatioMedia_1 * incrementRatioMedia_1 + 1);
                    }
                    ////////////////////////////////////////////////////////////
                    if(Media2Finish&&Media1Finish){
                      var inteGRPs = incrementMedia_1_GRPs + incrementMedia_2_GRPs;
                      var inteReach1 = self.calculationReach(data[0], inteGRPs);
                      mediaTemplate.resultMedia = data[0];
                      mediaTemplate.resultMedia.reach1 = parseFloat(inteReach1);
                      self.$log.debug('Media Logic Level Result PD+MO+Digital Inte. Logic 최종 reach1 : ' + mediaTemplate.resultMedia.reach1);
                      mediaTemplate.resultMedia.grps = parseFloat(originalInteGRPs);
                      // var reach3 = reach3Logic.Digital_R3(mediaTemplate.resultMedia.reach1, mediaTemplate.resultMedia.grps); // r3구하기
                      // mediaTemplate.resultMedia.reach3 = reach3;
                      // clearInterval(calculationInterval);
                      break;
                    }
                  }
                }
             }
        });
    },
    checkOverall(){

    }
    ,
    calcEImp(cffcnt) {
      cffcnt.eImp=((cffcnt.budget*10000)/cffcnt.cpm*1000);
    }
    ,
    calcGrps(cffcnt) {
      cffcnt.grps=((cffcnt.eImp/cffcnt.population)*100).toFixed(2);
    },
    // index_4 결과 데이터 만들기 (table / VennDiagram ... )
    makeFinalMediaList(){ // 마지막으로 화면에 그릴데이터 만들기
      var combindMediaList = [];
      if(this.tvMedia.resultMedia !== null){ // index_4-1 TV매체 결과데이터만들기
        // this.$log.debug('Media Level Result TV Media Screen : Count ' + this.tvMedia.screenCoun);
        this.$log.debug('Media Level Result TV Media ' + this.tvMedia.screenCount + ' Screen 벤다이어그램 그리기');
        combindMediaList.push(this.tvMedia.resultMedia);
        // 벤다이아그램처리로직
        switch (this.tvMedia.screenCount) {
          case 1:
            // 1스크린 벤다이어그램
            this.make1ScreenVennDiagram(this.tvMedia, 'TV');
            break;
          case 2:
            // 2스크린 벤다이어그램
            this.make2ScreenVennDiagram(this.tvMedia, 'TV');
            break;
          case 3:
            // 3스크린 벤다이어그램
            this.make3ScreenVennDiagram(this.tvMedia, 'TV');
            break;
          case 4:
            // 4스크린 벤다이어그램
            break;
        }
        // [Strat] TV reach3 계산
        var reach3 = reach3Logic.TV_R3(this.tvMedia.resultMedia.reach1, this.tvMedia.resultMedia.grps);
        this.tvMedia.resultMedia.reach3 = parseFloat(reach3).toFixed(2);
        this.$log.debug('Media Level Result TV Media Reach3 : ' + this.tvMedia.resultMedia.reach3);
        // [end] TV reach3 계산
        this.tvMedia.resultMedia.af = (parseFloat(this.tvMedia.resultMedia.grps) / parseFloat(this.tvMedia.resultMedia.reach1)).toFixed(2);
        this.tvMedia.resultMedia.reach1 = parseFloat(this.tvMedia.resultMedia.reach1).toFixed(2);
        this.tvMedia.resultMedia.grps = parseFloat(this.tvMedia.resultMedia.grps).toFixed(2);

      }
      if(this.pcMedia.resultMedia !== null){ // index_4-2 PC매체 결과데이터만들기
        this.$log.debug('Media Level Result PC Media ' + this.pcMedia.screenCount + ' Screen 벤다이어그램 그리기');
        combindMediaList.push(this.pcMedia.resultMedia);
        // 벤다이아그램처리로직
        switch (this.pcMedia.screenCount) {
          case 1:
            // 1스크린 벤다이어그램
            this.make1ScreenVennDiagram(this.pcMedia, 'PC');
            break;
          case 2:
            // 2스크린 벤다이어그램
            this.make2ScreenVennDiagram(this.pcMedia, 'PC');
            break;
          case 3:
            // 3스크린 벤다이어그램
            this.make3ScreenVennDiagram(this.pcMedia, 'PC');
            break;
          case 4:
            // 4스크린 벤다이어그램
            break;
        }
        // [Strat] PC reach3 계산
        var reach3 = reach3Logic.PC_R3(this.pcMedia.resultMedia.reach1, this.pcMedia.resultMedia.grps);
        this.pcMedia.resultMedia.reach3 = parseFloat(reach3).toFixed(2);
        this.$log.debug('Media Level Result PC Media Reach3 : ' + this.pcMedia.resultMedia.reach3);
        // [end] PC reach3 계산
        this.pcMedia.resultMedia.af = (parseFloat(this.pcMedia.resultMedia.grps) / parseFloat(this.pcMedia.resultMedia.reach1)).toFixed(2);
        this.pcMedia.resultMedia.reach1 = parseFloat(this.pcMedia.resultMedia.reach1).toFixed(2);
        this.pcMedia.resultMedia.grps = parseFloat(this.pcMedia.resultMedia.grps).toFixed(2);
      }
      if(this.mobileMedia.resultMedia !== null){ // index_4-3 mobile매체 결과데이터만들기
        this.$log.debug('Media Level Result Mobile Media ' + this.mobileMedia.screenCount + ' Screen 벤다이어그램 그리기');
        combindMediaList.push(this.mobileMedia.resultMedia);
        switch (this.mobileMedia.screenCount) {
          case 1:
            // 1스크린 벤다이어그램
            this.make1ScreenVennDiagram(this.mobileMedia, 'Mobile');
            break;
          case 2:
            // 2스크린 벤다이어그램
            this.make2ScreenVennDiagram(this.mobileMedia, 'Mobile');
            break;
          case 3:
            // 3스크린 벤다이어그램
            this.make3ScreenVennDiagram(this.mobileMedia, 'Mobile');
            break;
          case 4:
            // 4스크린 벤다이어그램
            break;
        }
        // [Strat] Mobile reach3 계산
        var reach3 = reach3Logic.Mobile_R3(this.mobileMedia.resultMedia.reach1, this.mobileMedia.resultMedia.grps);
        this.mobileMedia.resultMedia.reach3 = parseFloat(reach3).toFixed(2);
        this.$log.debug('Media Level Result Mobile Media Reach3 : ' + this.mobileMedia.resultMedia.reach3);
        // [end] Mobile reach3 계산
        this.mobileMedia.resultMedia.af = (parseFloat(this.mobileMedia.resultMedia.grps) / parseFloat(this.mobileMedia.resultMedia.reach1)).toFixed(2);
        this.mobileMedia.resultMedia.reach1 = parseFloat(this.mobileMedia.resultMedia.reach1).toFixed(2);
        this.mobileMedia.resultMedia.grps = parseFloat(this.mobileMedia.resultMedia.grps).toFixed(2);
      }
      if(this.digitalMedia.resultMedia !== null){ // index_4-4 digital매체 결과데이터만들기
        this.$log.debug('Media Level Result DigitalMedia Media ' + this.digitalMedia.screenCount + ' Screen 벤다이어그램 그리기');
        combindMediaList.push(this.digitalMedia.resultMedia);
        switch (this.digitalMedia.screenCount) {
          case 1:
            // 1스크린 벤다이어그램
            this.make1ScreenVennDiagram(this.digitalMedia, 'Digital');
            break;
          case 2:
            // 2스크린 벤다이어그램
            this.make2ScreenVennDiagram(this.digitalMedia, 'Digital');
            break;
          case 3:
            // 3스크린 벤다이어그램
            this.make3ScreenVennDiagram(this.digitalMedia, 'Digital');
            break;
          case 4:
            // 4스크린 벤다이어그램
            break;
        }
        // [Strat] Digital reach3 계산
        var reach3 = reach3Logic.Digital_R3(this.digitalMedia.resultMedia.reach1, this.digitalMedia.resultMedia.grps);
        this.digitalMedia.resultMedia.reach3 = parseFloat(reach3).toFixed(2);
        this.$log.debug('Media Level Result Digital Media Reach3 : ' + this.digitalMedia.resultMedia.reach3);
        // [end] Digital reach3 계산
        this.digitalMedia.resultMedia.af = (parseFloat(this.digitalMedia.resultMedia.grps) / parseFloat(this.digitalMedia.resultMedia.reach1)).toFixed(2);
        this.digitalMedia.resultMedia.reach1 = parseFloat(this.digitalMedia.resultMedia.reach1).toFixed(2);
        this.digitalMedia.resultMedia.grps = parseFloat(this.digitalMedia.resultMedia.grps).toFixed(2);
      }
      this.formData.mediaListResult = combindMediaList;
      this.rootFormData.mediaListResult = combindMediaList;

      // 미니테이블에 필요한 데이터 만들기
      var mediaList_tmp = {};
      for(var i=0; i<this.formData.mediaListResult.length; i++){
        this.formData.mediaListResult[i].tag = '';
        for(var j=0; j< this.constFormData.length; j++){
          if(this.formData.mediaListResult[i].media == this.constFormData[j].media){

            var tmp = mediaList_tmp[this.formData.mediaListResult[i].media];
            if(tmp == null){
              mediaList_tmp[this.formData.mediaListResult[i].media] = this.formData.mediaListResult[i];
            }else{
              this.formData.mediaListResult[i].budgetLabel = '(multiple)';
              this.formData.mediaListResult[i].cpmLabel    = '(multiple)';
            }
            this.formData.mediaListResult[i].tag += '<tr>'
                        +'<td>'+ this.constFormData[j].channel +'</td>'
                        +'<td>'+ this.constFormData[j].vehicle +'</td>'
                        +'<td>'+ this.constFormData[j].targetCode +'</td>'
                        +'<td>'+ this.constFormData[j].budgetStr +'</td>'
                        +'<td>'+ this.constFormData[j].cpmStr +'</td>'
                        +'<td>'+ this.constFormData[j].eImpStr +'</td>'
                      +'</tr>';
          }
        }
      }

      var self = this;
      $(function () {
      $('#mediaTable').bootstrapTable({
            height : 400,
            data: self.formData.mediaListResult,
            onClickRow: function (row, $element) {
              $($element).addClass('selectedActive').siblings().removeClass('selectedActive');
              self.changeChart((row.media));
            },
            detailFormatter: function(index, row) {
              var html = [];
              html.push('<table>');
              var str = '<tr><th>채널</th><th>비히클</th><th>타겟</th><th>예산</th><th>CPM</th><th>E.Imp</th></tr>';
              html.push(str);
              $.each(row, function(key, value) {
                if(key == 'tag'){
                  html.push(value);
                }
              });
              html.push('</table>');
              // join() 메서드는 배열의 모든 요소를 연결해 하나의 문자열로 만듦
              return html.join('');
            }
        });
          var first = $("#mediaTable > tbody tr:first")
          $(first).addClass('selectedActive').siblings().removeClass('selectedActive');
        });

      // 최종 ...
      this.changeChart(combindMediaList[0].media);
      this.completeMediaLevelCalculation = true;
      // 토탈레벨 분석 실행 플레그
    },

    changeChart(mediaName) {
      switch (mediaName) {
        case 'TV':
          this.tvMediaShow=true;
          this.pcMediaShow=false;
          this.mobileMediaShow=false;
          this.digitalMediaShow=false;
          break;
        case 'PC':
          this.tvMediaShow=false;
          this.pcMediaShow=true;
          this.mobileMediaShow=false;
          this.digitalMediaShow=false;
          break;
        case 'Mobile':
          this.tvMediaShow=false;
          this.pcMediaShow=false;
          this.mobileMediaShow=true;
          this.digitalMediaShow=false;
          break;
        case 'Digital':
          this.tvMediaShow=false;
          this.pcMediaShow=false;
          this.mobileMediaShow=false;
          this.digitalMediaShow=true;
          break;
        default:

      }
    },
    chartChangeFn(){
      this.chartChange = !this.chartChange;
      if(this.chartChange){
        this.chartChangeLable = '교집합 벤다이어그램'
      }else{
        this.chartChangeLable = 'Integrated 벤다이어그램'
      }
    },
    totalLevelChartChangeFn(){
      this.totalLevelChartChange = !this.totalLevelChartChange;
      if(this.totalLevelChartChange){
        this.totalLevelChartChangeLable = '교집합 벤다이어그램'
      }else{
        this.totalLevelChartChangeLable = 'Integrated 벤다이어그램'
      }
    },
    // index_5-1 1screen 벤다이어그램 그리기
    make1ScreenVennDiagram(mediaData, mediaName){
      this.totalMedia = mediaData;
      var node1_id = '#mediaLevel_' + mediaName + '_Venn1';
      var node2_id = '#mediaLevel_' + mediaName + '_Venn2';

      var reach1 = parseFloat(mediaData.resultMedia.reach1).toFixed(2);

      var ALabel = mediaName + " " + reach1 + ' ' + '%';
      var sets = [ {sets: ['0'], label : ALabel, size: reach1}
                 ];
      var chart = venn.VennDiagram().height(430);
      var node1 = d3.select(node1_id).datum(sets).call(chart);
      node1.selectAll("text").style("font-weight", "600").style("font-size", "16px");
      /////////////////////////////////////////////////////////////////////////
      var chart = venn.VennDiagram().height(430);
      var node2 = d3.select(node2_id).datum(sets).call(chart);
      d3.selectAll(node2_id +" .venn-circle path")
      .style("fill-opacity", 5)
      .style("stroke-width", 1)
      // .style("stroke-opacity", 10)
      .style("fill", "#BDC3C7")
      .style("stroke", "#BDC3C7");

      node2.selectAll("text").style("font-weight", "600") //selectALL 과 select의 차이 이해
                           .style("font-size", "26px")
                           .style("fill", "#ffff");
      node2.selectAll("tspan").attr('y', '220').attr('x', '300');
    },
    // index_5-2 2screen 벤다이어그램 그리기
    make2ScreenVennDiagram(mediaData, mediaName){
      var node1_id = '#mediaLevel_' + mediaName + '_Venn1';
      var node2_id = '#mediaLevel_' + mediaName + '_Venn2';
      var intersection = (parseFloat(mediaData.reachA) + parseFloat(mediaData.reachB)) - parseFloat(mediaData.resultMedia.reach1);

      if(intersection < 0){
        // intersection 마이너스값 발생될경우에 대한 처리 필요
        intersection = 0;
      }
      var interLabel = intersection.toFixed(2) + '%';
      var ALabel = mediaData.reachALabel + ' ' + parseFloat(mediaData.reachA).toFixed(2) + '%';
      var BLabel = mediaData.reachBLabel + ' ' + parseFloat(mediaData.reachB).toFixed(2) + '%';
      var sets = [ {sets: ['0'], label : ALabel, size: mediaData.reachA},
                   {sets: ['1'], label : BLabel, size: mediaData.reachB},
                   {sets: ['0','1'], label : interLabel, size: intersection},
                 ];
      var chart = venn.VennDiagram().height(430);
      var node1 = d3.select(node1_id).datum(sets).call(chart);
      node1.selectAll("text").style("font-weight", "600").style("font-size", "16px");
      /////////////////////////////////////////////////////////////////////////
      var inteReach1 = parseFloat(mediaData.resultMedia.reach1).toFixed(2);
      var inteReach1Label = 'Total Reach : ' + inteReach1 +'%'

      var sets2 = [ {sets: ['0'], label :  ' ', size: mediaData.reachA},
                   {sets: ['1'], label : inteReach1Label, size: mediaData.reachB},
                   {sets: ['0','1'], size: intersection},
                 ];
      var chart = venn.VennDiagram().height(430);
      var node2 = d3.select(node2_id).datum(sets2).call(chart);
      d3.selectAll(node2_id +" .venn-circle path")
      .style("fill-opacity", 5)
      .style("stroke-width", 1)
      .style("fill", "#BDC3C7")
      .style("stroke", "#BDC3C7");

      node2.selectAll("text").style("font-weight", "600") //selectALL 과 select의 차이 이해
                           .style("font-size", "26px")
                           .style("fill", "#ffff");
      node2.selectAll("tspan").attr('y', '220').attr('x', '300');
    },
    // index_5-3 3screen 벤다이어그램 그리기
    make3ScreenVennDiagram(mediaData, mediaName){
      var node1_id = '#mediaLevel_' + mediaName + '_Venn1';
      var node2_id = '#mediaLevel_' + mediaName + '_Venn2';

      var intersection1 = (parseFloat(mediaData.reachA) + parseFloat(mediaData.reachB)) - parseFloat(mediaData.reachAB);
      var intersection2 = (parseFloat(mediaData.reachA) + parseFloat(mediaData.reachC)) - parseFloat(mediaData.reachAC);
      var intersection3 = (parseFloat(mediaData.reachB) + parseFloat(mediaData.reachC)) - parseFloat(mediaData.reachBC);
      var intersection4 = parseFloat(mediaData.reachABC) - (parseFloat(mediaData.reachA)
                          + parseFloat(mediaData.reachB) + parseFloat(mediaData.reachC)) + (intersection1 + intersection2 + intersection3);

      var outputIntersection1 = intersection1 - intersection4;
      var outputIntersection2 = intersection2 - intersection4;
      var outputIntersection3 = intersection3 - intersection4;

      intersection1 = intersection1<0?0:intersection1; // 임시방편
      intersection2 = intersection2<0?0:intersection2; // 임시방편
      intersection3 = intersection3<0?0:intersection3; // 임시방편
      intersection4 = intersection4<0?0:intersection4; // 임시방편

      var interLabel1 = intersection1.toFixed(2) + '%';
      var interLabel2 = intersection2.toFixed(2) + '%';
      var interLabel3 = intersection3.toFixed(2) + '%';
      var interLabel4 = intersection4.toFixed(2) + '%';
      var ALabel = mediaData.reachALabel + ' ' + (parseFloat(mediaData.reachA).toFixed(2)) + '%';
      var BLabel = mediaData.reachBLabel + ' ' + (parseFloat(mediaData.reachB).toFixed(2)) + '%';
      var CLabel = mediaData.reachCLabel + ' ' + (parseFloat(mediaData.reachC).toFixed(2)) + '%';
      var sets = [ {sets: ['1'], label : ALabel, size: mediaData.reachA},
                   {sets: ['2'], label : BLabel, size: mediaData.reachB},
                   {sets: ['3'], label : CLabel, size: mediaData.reachC},
                   {sets: ['1','2'], label : interLabel1, size: intersection1},
                   {sets: ['1','3'], label : interLabel2, size: intersection2},
                   {sets: ['2','3'], label : interLabel3, size: intersection3},
                   {sets: ['1','2','3'], label : interLabel4, size: intersection4},
                 ];
      var chart = venn.VennDiagram().height(430);
      var node1 = d3.select(node1_id).datum(sets).call(chart);
      node1.selectAll("text").style("font-weight", "600").style("font-size", "16px");
      /////////////////////////////////////////////////////////////////////////
      var inteReach1 = parseFloat(mediaData.resultMedia.reach1).toFixed(2);
      var inteReach1Label = 'Total Reach : ' + inteReach1 +'%'
      var sets2 = [ {sets: ['1'], label : ' ', size: mediaData.reachA},
                   {sets: ['2'], label : ' ', size: mediaData.reachB},
                   {sets: ['3'], label : inteReach1Label, size: mediaData.reachC},
                   {sets: ['1','2'], label : ' ', size: intersection1},
                   {sets: ['1','3'], label : ' ', size: intersection2},
                   {sets: ['2','3'], label : ' ', size: intersection3},
                   {sets: ['1','2','3'], label : ' ', size: intersection4},
                 ];
      var chart = venn.VennDiagram().height(430);
      var node2 = d3.select(node2_id).datum(sets2).call(chart);
      d3.selectAll(node2_id +" .venn-circle path")
      .style("fill-opacity", 5)
      .style("stroke-width", 1)
      .style("fill", "#BDC3C7")
      .style("stroke", "#BDC3C7");

      node2.selectAll("text").style("font-weight", "600") //selectALL 과 select의 차이 이해
                           .style("font-size", "26px")
                           .style("fill", "#ffff");
      node2.selectAll("tspan").attr('y', '250').attr('x', '300');

    },
    // index_5-4 4screen 벤다이어그램 그리기
    make4ScreenVennDiagram(mediaData, mediaName){

    },
    // index_6-1 토탈레벨 분석코드 생성
    makeTotalLevelCode(){
      // totalLevelCode
      if(this.tvMedia.resultMedia !== null){
        this.totalLevelCode += 'T'
      }
      if(this.pcMedia.resultMedia !== null){
        this.totalLevelCode += 'P'
      }
      if(this.mobileMedia.resultMedia !== null){
        this.totalLevelCode += 'M'
      }
      if(this.digitalMedia.resultMedia !== null){
        this.totalLevelCode += 'D'
      }
      this.$log.debug('Media Total Level Result Total Level CODE : ' + this.totalLevelCode);
    },
    // index_6-2 토탈레벨 데이터 분석
    calcTotalLevel(){
      switch (this.totalLevelCode) {
        case 'T':
          this.$log.debug('Media Total Level [T] Total reach1 :' + this.tvMedia.resultMedia.reach1);
          this.$log.debug('Media Total Level [T] Total reach3 :' + this.tvMedia.resultMedia.reach3);
          this.make1ScreenVennDiagram(this.tvMedia, 'TOTAL');
          break;
        case 'P':
          this.$log.debug('Media Total Level [P] Total reach1 :' + this.pcMedia.resultMedia.reach1);
          this.$log.debug('Media Total Level [P] Total reach3 :' + this.pcMedia.resultMedia.reach3);
          this.make1ScreenVennDiagram(this.pcMedia, 'TOTAL');
          break;
        case 'M':
          this.$log.debug('Media Total Level [M] Total reach1 :' + this.mobileMedia.resultMedia.reach1);
          this.$log.debug('Media Total Level [M] Total reach3 :' + this.mobileMedia.resultMedia.reach3);
          this.make1ScreenVennDiagram(this.mobileMedia, 'TOTAL');
          break;
        case 'D':
          this.$log.debug('Media Total Level [D] Total reach1 :' + this.digitalMedia.resultMedia.reach1);
          this.$log.debug('Media Total Level [D] Total reach3 :' + this.digitalMedia.resultMedia.reach3);
          this.make1ScreenVennDiagram(this.digitalMedia, 'TOTAL');
          break;
        case 'TP':
          this.totalMedia.reachA = this.tvMedia.resultMedia.reach1;
          this.totalMedia.reachALabel = 'TV';
          this.totalMedia.reachB = this.pcMedia.resultMedia.reach1;
          this.totalMedia.reachBLabel = 'PC';
          var reach3 = reach3Logic.TV_PC_MO_R3(this.tvMedia.resultMedia.reach3, this.pcMedia.resultMedia.reach3); // r3구하기

          // this.A2_Logic(this.totalMedia, this.tvMedia.resultMedia, this.pcMedia.resultMedia, 'A2_7', 'total');
          this.BN2_Logic(this.totalMedia, this.tvMedia.resultMedia, this.pcMedia.resultMedia, 'BN2_8');
          this.totalMedia.resultMedia.reach3 = reach3; // r3구하기
          this.$log.debug('Media Total Level [TP] TV    reach1 :' + this.totalMedia.reachA);
          this.$log.debug('Media Total Level [TP] PC    reach1 :' + this.totalMedia.reachB);
          this.$log.debug('Media Total Level [TP] Total reach1 :' + this.totalMedia.resultMedia.reach1);
          this.$log.debug('Media Total Level [TP] Total reach3 :' + this.totalMedia.resultMedia.reach3);
          this.make2ScreenVennDiagram(this.totalMedia, 'TOTAL');
          break;
        case 'TM':
          this.totalMedia.reachA = this.tvMedia.resultMedia.reach1;
          this.totalMedia.reachALabel = 'TV';
          this.totalMedia.reachB = this.mobileMedia.resultMedia.reach1;
          this.totalMedia.reachBLabel = 'Mobile';
          var reach3 = reach3Logic.TV_PC_MO_R3(this.tvMedia.resultMedia.reach3, this.mobileMedia.resultMedia.reach3); // r3구하기

          // this.A2_Logic(this.totalMedia, this.tvMedia.resultMedia, this.mobileMedia.resultMedia, 'A2_8', 'total');
          this.BN2_Logic(this.totalMedia, this.tvMedia.resultMedia, this.mobileMedia.resultMedia, 'BN2_9');
          this.totalMedia.resultMedia.reach3 = reach3; // r3구하기
          this.$log.debug('Media Total Level [TM] TV     reach1 :' + this.totalMedia.reachA);
          this.$log.debug('Media Total Level [TM] mobile reach1 :' + this.totalMedia.reachB);
          this.$log.debug('Media Total Level [TM] Total  reach1 :' + this.totalMedia.resultMedia.reach1);
          this.$log.debug('Media Total Level [TM] Total  reach3 :' + this.totalMedia.resultMedia.reach3);
          this.make2ScreenVennDiagram(this.totalMedia, 'TOTAL');
          break;
        case 'TD':
          this.totalMedia.reachA = this.tvMedia.resultMedia.reach1;
          this.totalMedia.reachALabel = 'TV';
          this.totalMedia.reachB = this.digitalMedia.resultMedia.reach1;
          this.totalMedia.reachBLabel = 'Digital';
          var reach3 = reach3Logic.TV_PC_MO_R3(this.tvMedia.resultMedia.reach3, this.digitalMedia.resultMedia.reach3); // r3구하기

          // this.A2_Logic(this.totalMedia, this.tvMedia.resultMedia, this.digitalMedia.resultMedia, 'A2_5', 'total');
          this.BN2_Logic(this.totalMedia, this.tvMedia.resultMedia, this.digitalMedia.resultMedia, 'BN2_6');
          this.totalMedia.resultMedia.reach3 = reach3; // r3구하기
          this.$log.debug('Media Total Level [TD] TV      reach1 :' + this.totalMedia.reachA);
          this.$log.debug('Media Total Level [TD] digital reach1 :' + this.totalMedia.reachB);
          this.$log.debug('Media Total Level [TD] Total   reach1 :' + this.totalMedia.resultMedia.reach1);
          this.$log.debug('Media Total Level [TD] Total   reach3 :' + this.totalMedia.resultMedia.reach3);
          this.make2ScreenVennDiagram(this.totalMedia, 'TOTAL');
          break;
        case 'PM':
          this.totalMedia.reachA = this.pcMedia.resultMedia.reach1;
          this.totalMedia.reachALabel = 'PC';
          this.totalMedia.reachB = this.mobileMedia.resultMedia.reach1;
          this.totalMedia.reachBLabel = 'Mobile';

          var reach3 = reach3Logic.PC_MO_R3(this.pcMedia.resultMedia.reach3, this.mobileMedia.resultMedia.reach3);
          // this.A2_Logic(this.totalMedia, this.pcMedia.resultMedia, this.mobileMedia.resultMedia, 'A2_6', 'total');
          this.BN2_Logic(this.totalMedia, this.pcMedia.resultMedia, this.mobileMedia.resultMedia, 'BN2_7');
          this.totalMedia.resultMedia.reach3 = reach3;
          this.$log.debug('Media Total Level [PM] PC     reach1 :' + this.totalMedia.reachA);
          this.$log.debug('Media Total Level [PM] Mobile reach1 :' + this.totalMedia.reachB);
          this.$log.debug('Media Total Level [PM] Total  reach1 :' + this.totalMedia.resultMedia.reach1);
          this.$log.debug('Media Total Level [PM] Total  reach3 :' + this.totalMedia.resultMedia.reach3);
          this.make2ScreenVennDiagram(this.totalMedia, 'TOTAL');
          break;
        case 'PD':
          this.digital_Inte_Logic(this.totalMedia, this.digitalMedia.resultMedia, this.pcMedia.resultMedia);
          var reach3 = reach3Logic.Digital_R3(this.totalMedia.resultMedia.reach1, this.totalMedia.resultMedia.grps); // r3구하기
          this.totalMedia.resultMedia.reach3 = reach3;
          this.$log.debug('Media Total Level [PD] Digital reach1 :' + this.digitalMedia.resultMedia.reach1);
          // this.$log.debug('Media Total Level [PD] PC      reach1 :' + this.mobileMedia.resultMedia.reach1);
          this.$log.debug('Media Total Level [PD] Total   reach1 :' + this.totalMedia.resultMedia.reach1);
          this.$log.debug('Media Total Level [PD] Total   reach3 :' + reach3);
          this.make1ScreenVennDiagram(this.totalMedia, 'TOTAL');
          break;
        case 'MD':
          this.digital_Inte_Logic(this.totalMedia, this.digitalMedia.resultMedia, this.mobileMedia.resultMedia);
          var reach3 = reach3Logic.Digital_R3(this.totalMedia.resultMedia.reach1, this.totalMedia.resultMedia.grps); // r3구하기
          this.totalMedia.resultMedia.reach3 = reach3;
          this.$log.debug('Media Total Level [MD] Digital reach1 :' + this.digitalMedia.resultMedia.reach1);
          this.$log.debug('Media Total Level [MD] Mobile  reach1 :' + this.mobileMedia.resultMedia.reach1);
          this.$log.debug('Media Total Level [MD] Total   reach1 :' + this.totalMedia.resultMedia.reach1);
          this.$log.debug('Media Total Level [MD] Total   reach3 :' + reach3);
          this.make1ScreenVennDiagram(this.totalMedia, 'TOTAL');
          break;
        case 'TPD':
          this.digital_Inte_Logic(this.totalMedia, this.digitalMedia.resultMedia, this.pcMedia.resultMedia);
          var digital = this.$_.clone(this.totalMedia);

          this.totalMedia.reachA = this.tvMedia.resultMedia.reach1;
          this.totalMedia.reachALabel = 'TV';
          this.totalMedia.reachB = digital.resultMedia.reach1;
          this.totalMedia.reachBLabel = 'Digital';
          var digital_R3 = reach3Logic.Digital_R3(digital.resultMedia.reach1, digital.resultMedia.grps); // r3구하기
          var reach3 = reach3Logic.TV_PC_MO_R3(this.tvMedia.resultMedia.reach3, digital_R3); // r3구하기

          // this.A2_Logic(this.totalMedia, this.tvMedia.resultMedia, digital.resultMedia, 'A2_5', 'total');
          this.BN2_Logic(this.totalMedia, this.tvMedia.resultMedia, digital.resultMedia, 'BN2_6');
          this.totalMedia.resultMedia.reach3 = reach3; // r3구하기

          this.$log.debug('Media Total Level [TPD] TV      reach1 :' + this.totalMedia.reachA);
          this.$log.debug('Media Total Level [TPD] Digital reach1 :' + this.digitalMedia.resultMedia.reach1);
          this.$log.debug('Media Total Level [TPD] PC      reach1 :' + this.pcMedia.resultMedia.reach1);
          this.$log.debug('Media Total Level [TPD] Di+PC   reach1 :' + this.totalMedia.reachB);
          this.$log.debug('Media Total Level [TPD] Total   reach1 :' + this.totalMedia.resultMedia.reach1);
          this.$log.debug('Media Total Level [TPD] Total   reach3 :' + this.totalMedia.resultMedia.reach3);
          this.make2ScreenVennDiagram(this.totalMedia, 'TOTAL');

          break;
        case 'TMD':
          this.digital_Inte_Logic(this.totalMedia, this.digitalMedia.resultMedia, this.mobileMedia.resultMedia);
          var digital = this.$_.clone(this.totalMedia);

          this.totalMedia.reachA = this.tvMedia.resultMedia.reach1;
          this.totalMedia.reachALabel = 'TV';
          this.totalMedia.reachB = digital.resultMedia.reach1;
          this.totalMedia.reachBLabel = 'Digital';
          var digital_R3 = reach3Logic.Digital_R3(digital.resultMedia.reach1, digital.resultMedia.grps); // r3구하기
          var reach3 = reach3Logic.TV_PC_MO_R3(this.tvMedia.resultMedia.reach3, digital_R3); // r3구하기

          // this.A2_Logic(this.totalMedia, this.tvMedia.resultMedia, digital.resultMedia, 'A2_5', 'total');
          this.BN2_Logic(this.totalMedia, this.tvMedia.resultMedia, digital.resultMedia, 'BN2_6');
          this.totalMedia.resultMedia.reach3 = reach3; // r3구하기

          this.$log.debug('Media Total Level [TMD] TV        reach1 :' + this.totalMedia.reachA);
          this.$log.debug('Media Total Level [TMD] Digital   reach1 :' + this.digitalMedia.resultMedia.reach1);
          this.$log.debug('Media Total Level [TMD] Mobile    reach1 :' + this.mobileMedia.resultMedia.reach1);
          this.$log.debug('Media Total Level [TMD] Di+Mobile reach1 :' + this.totalMedia.reachB);
          this.$log.debug('Media Total Level [TMD] Total     reach1 :' + this.totalMedia.resultMedia.reach1);
          this.$log.debug('Media Total Level [TMD] Total     reach3 :' + this.totalMedia.resultMedia.reach3);
          this.make2ScreenVennDiagram(this.totalMedia, 'TOTAL');

          break;
        case 'TPM':

          this.totalMedia.reachA = this.tvMedia.resultMedia.reach1;
          this.totalMedia.reachALabel = 'TV';
          this.totalMedia.reachB = this.pcMedia.resultMedia.reach1;
          this.totalMedia.reachBLabel = 'PC';
          this.totalMedia.reachC = this.mobileMedia.resultMedia.reach1;
          this.totalMedia.reachCLabel = 'Mobile';

          var pcmoReach3 = reach3Logic.PC_MO_R3(this.pcMedia.resultMedia.reach3, this.mobileMedia.resultMedia.reach3); // r3구하기
          var reach3 = reach3Logic.TV_PC_MO_R3(this.tvMedia.resultMedia.reach3, pcmoReach3); // r3구하기

          var tvMediaResult = this.$_.clone(this.tvMedia.resultMedia);
          var pcMediaResult = this.$_.clone(this.pcMedia.resultMedia);
          var mobileMediaResult = this.$_.clone(this.mobileMedia.resultMedia);

          // this.A2_Logic(this.totalMedia, tvMediaResult, pcMediaResult, 'A2_7', 'total');
          this.BN2_Logic(this.totalMedia, tvMediaResult, pcMediaResult, 'BN2_8');
          this.totalMedia.reachAB = this.totalMedia.resultMedia.reach1;

          // this.A2_Logic(this.totalMedia, tvMediaResult, mobileMediaResult, 'A2_8', 'total');
          this.BN2_Logic(this.totalMedia, tvMediaResult, mobileMediaResult, 'BN2_9');
          this.totalMedia.reachAC = this.totalMedia.resultMedia.reach1;

          // this.A2_Logic(this.totalMedia, pcMediaResult, mobileMediaResult, 'A2_6', 'total');
          this.BN2_Logic(this.totalMedia, pcMediaResult, mobileMediaResult, 'BN2_7');
          this.totalMedia.reachBC = this.totalMedia.resultMedia.reach1;

          // this.A3_Logic(this.totalMedia, tvMediaResult, pcMediaResult, mobileMediaResult,'A3_2', 'total');
          this.BN3_Logic(this.totalMedia, tvMediaResult, pcMediaResult, mobileMediaResult,'BN3_2', 'media');
          this.totalMedia.reachABC = this.totalMedia.resultMedia.reach1;
          this.totalMedia.resultMedia.reach3 = reach3; // r3구하기

          this.$log.debug('Media Total Level [TPM] TV     reach1 :' + this.totalMedia.reachA);
          this.$log.debug('Media Total Level [TPM] PC     reach1 :' + this.totalMedia.reachB);
          this.$log.debug('Media Total Level [TPM] Mobile reach1 :' + this.totalMedia.reachC);
          this.$log.debug('Media Total Level [TPM] Total  reach1 :' + this.totalMedia.resultMedia.reach1);
          this.$log.debug('Media Total Level [TPM] Total  reach3 :' + this.totalMedia.resultMedia.reach3);
          this.make3ScreenVennDiagram(this.totalMedia, 'TOTAL');

          break;
        case 'PMD':
          this.digital_Inte_Logic(this.totalMedia, this.digitalMedia.resultMedia, this.mobileMedia.resultMedia);
          var digital = this.$_.clone(this.totalMedia);
          this.digital_Inte_Logic(this.totalMedia, digital.resultMedia, this.pcMedia.resultMedia);

          var reach3 = reach3Logic.Digital_R3(this.totalMedia.resultMedia.reach1, this.totalMedia.resultMedia.grps); // r3구하기
          this.totalMedia.resultMedia.reach3 = reach3;

          this.$log.debug('Media Total Level [PMD] digital reach1 :' + this.digitalMedia.resultMedia.reach1);
          this.$log.debug('Media Total Level [PMD] mobile  reach1 :' + this.mobileMedia.resultMedia.reach1);
          this.$log.debug('Media Total Level [PMD] pc      reach1 :' + this.pcMedia.resultMedia.reach1);
          this.$log.debug('Media Total Level [PMD] Total   reach1 :' + this.totalMedia.resultMedia.reach1);
          this.$log.debug('Media Total Level [PMD] Total   reach3 :' + this.totalMedia.resultMedia.reach3);
          this.make1ScreenVennDiagram(this.totalMedia, 'TOTAL');
          break;
        case 'TPMD':
          this.digital_Inte_Logic(this.totalMedia, this.digitalMedia.resultMedia, this.mobileMedia.resultMedia);
          var digital = this.$_.clone(this.totalMedia);
          this.digital_Inte_Logic(this.totalMedia, digital.resultMedia, this.pcMedia.resultMedia);
          digital = this.$_.clone(this.totalMedia);

          this.totalMedia.reachA = this.tvMedia.resultMedia.reach1;
          this.totalMedia.reachALabel = 'TV';
          this.totalMedia.reachB = digital.resultMedia.reach1;
          this.totalMedia.reachBLabel = 'Digital';

          var digital_R3 = reach3Logic.Digital_R3(digital.resultMedia.reach1, digital.resultMedia.grps); // r3구하기
          var reach3 = reach3Logic.TV_PC_MO_R3(this.tvMedia.resultMedia.reach3, digital_R3); // r3구하기

          // this.A2_Logic(this.totalMedia, this.tvMedia.resultMedia, digital.resultMedia, 'A2_5', 'total');
          this.BN2_Logic(this.totalMedia, this.tvMedia.resultMedia, digital.resultMedia, 'BN2_6');
          this.totalMedia.resultMedia.reach3 = reach3;

          this.$log.debug('Media Total Level [TMD] TV           reach1 :' + this.totalMedia.reachA);
          this.$log.debug('Media Total Level [TMD] Digital      reach1 :' + this.digitalMedia.resultMedia.reach1);
          this.$log.debug('Media Total Level [TMD] Mobile       reach1 :' + this.mobileMedia.resultMedia.reach1);
          this.$log.debug('Media Total Level [TMD] Di+PC+Mobile reach1 :' + this.totalMedia.reachB);
          this.$log.debug('Media Total Level [TMD] Total        reach1 :' + this.totalMedia.resultMedia.reach1);
          this.$log.debug('Media Total Level [TMD] Total        reach3 :' + this.totalMedia.resultMedia.reach3);
          this.make2ScreenVennDiagram(this.totalMedia, 'TOTAL');
          break;
        default:
        // 토탈레벨결과 show 플래그 true
      }
    }
  }
}
</script>
<style src="bootstrap-table/dist/bootstrap-table.min.css"></style>
<style src="../../../custom/amcharts/amchart_plugins.min.css"></style>
<style>
/* [시작] Help모달 버튼 CSS */
.block-options .btn {
  border-color: grey;
  border-radius: 15px;
  padding-top: 3px;
  padding-right: 10px;
  padding-left: 5px;
  max-height: 30px;
  max-width: 30px;
  text-align: center;
  background-color: #ffffff;
  /* background-color: red; */
  margin-top: 0;
  margin-bottom: 0;
}
/* [종료] Help모달 버튼 CSS */
</style>



// WEBPACK FOOTER //
// src/views/reach/result/MediaLevelResult.vue